import React, { useEffect, useState, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import * as env from 'config/environment';
import { useRouting } from 'hooks/useRouting';
import { formatDate } from 'utils/formatter';
import Loading from 'components/commons/loading/Loading';
import { isApp, isIosApp } from 'components/features/utils/userStatus';
import { getUserStorage } from 'components/features/utils/utils';
import LoginSideMenu from './components/LoginSideMenu';
import { HeadBlock } from './components/HeadBlock';

export type NotificationItems = {
  ID: string;
  Type: number;
  Title: string;
  Content: string;
  InsTime: string;
  UpdTime: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const $: any;

const Login: React.FC = () => {
  const [showImage, setShowImage] = useState<string>('');
  const [isShowSideMenu, setIsShowSideMenu] = useState(false);
  const [hideAnimate, setHideAnimate] = useState<boolean>(false);

  const menuShow = (): void => {
    setIsShowSideMenu(true);
    setHideAnimate(false);
  };
  const menuHide = (): void => {
    setIsShowSideMenu(false);
  };
  const menuHideAnimate = (): void => {
    setHideAnimate(true);
  };

  const routing = useRouting();
  const handlePremiumLp = (): void => {
    routing.pushRouting({ path: '/premiumLp' }, true);
  };

  const getURLWithParameter = (url: string): string => {
    return `${url}?service=${env.serviceName}&callback_url=${encodeURI(
      `${env.appURL}/auth`
    )}`;
  };
  const login = (): void => {
    window.location.href = getURLWithParameter(env.loginURL);
  };
  const register = (): void => {
    window.location.href = getURLWithParameter(env.registerURL);
  };
  const loginFromIosApp = (): void => {
    window.location.href = `${env.loginURL}?service=${
      env.serviceName
    }&callback_url=${encodeURI(`${env.spAppURL}/auth`)}`;
  };
  const registerFromIosApp = (): void => {
    window.location.href = `${env.registerURL}?service=${
      env.serviceName
    }&callback_url=${encodeURI(`${env.spAppURL}/auth`)}`;
  };

  const loginToSomewhere = (where: string) => () => {
    const s = `?callbackPath=${where}`;
    window.location.href = getURLWithParameter(env.loginURL) + s;
  };
  const loginTrade = loginToSomewhere('tradehistory');
  const loginReport = loginToSomewhere('dailyreport');
  const loginNotifiationSetting = loginToSomewhere('notificationSetting');
  const loginTarget = loginToSomewhere('target');
  const loginPersonaChart = loginToSomewhere('personachart');
  const loginDividend = loginToSomewhere('dividendprediction');

  const registerToSomewhere = (where: string) => () => {
    const s = `?callbackPath=${where}`;
    window.location.href = getURLWithParameter(env.registerURL) + s;
  };
  const registerTrade = registerToSomewhere('tradehistory');
  const registerReport = registerToSomewhere('dailyreport');
  const registerNotifiationSetting = registerToSomewhere('notificationSetting');
  const registerTarget = registerToSomewhere('target');
  const registerPersonaChart = registerToSomewhere('personachart');
  const registerDividend = registerToSomewhere('dividendprediction');

  const linkSecuritiesAccountManagementLP = () => {
    return `${env.appURL}/securitiesAccountManagementLP`;
  };

  const userStorage = getUserStorage();
  const isMinkabuMember = userStorage !== null ? true : false;

  const location = useLocation();
  const [scrollTarget, setScrollTarget] = useState(true);
  const scroll = useCallback(() => {
    if (location.hash !== '#target') return;
    const element = document.getElementById('target');
    element?.scrollIntoView();
    setScrollTarget(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollTarget]);

  const [scrollShisan, setScrollShisan] = useState(true);
  const reportShisan = useCallback(() => {
    if (location.hash !== '#shisan') return;
    const element = document.getElementById('shisan');
    element?.scrollIntoView();
    setScrollShisan(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollShisan]);

  const [scrollReport, setScrollReport] = useState(true);
  const reportScroll = useCallback(() => {
    if (location.hash !== '#report') return;
    const element = document.getElementById('report');
    element?.scrollIntoView();
    setScrollReport(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollReport]);

  const [scrollPersonachart, setScrollPersonachart] = useState(true);
  const reportPersonachart = useCallback(() => {
    if (location.hash !== '#personachart') return;
    const element = document.getElementById('personachart');
    element?.scrollIntoView();
    setScrollPersonachart(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollPersonachart]);

  const [scrollAccountInfo, setScrollAccountInfo] = useState(true);
  const accountInfoScroll = useCallback(() => {
    if (location.hash !== '#accountinfo') return;
    const element = document.getElementById('accountinfo');
    element?.scrollIntoView();
    setScrollAccountInfo(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollAccountInfo]);

  const closeModal = (): void => {
    setShowImage('');
  };

  const headers = {
    Accept: 'application/json',
  };

  const [notificationItems, setNotificationItems] = useState<
    NotificationItems[] | null
  >(null);

  useEffect(() => {
    document.domain === 'localhost'
      ? (async () => {
          const res = await fetch(
            `https://stg.tw.minkabu.jp/status/notifications.json`,
            {
              cache: 'no-cache',
              method: 'GET',
              headers,
            }
          );
          if (res.status === 200) {
            setNotificationItems((await res.json()) as NotificationItems[]);
          }
        })()
      : (async () => {
          const res = await fetch(`${env.appURL}/status/notifications.json`, {
            cache: 'no-cache',
            method: 'GET',
            headers,
          });
          if (res.status === 200) {
            setNotificationItems((await res.json()) as NotificationItems[]);
          }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    //toggle(表示・非表示の切り替え)
    //.js_toggle_switchのデータ属性(data-toggle="クラス名")と同じクラス名の要素の表示非表示の切り替えを行う
    //
    //sample
    //<button class="js_toggle_switch" data-toggle="js_rnavi">ボタン</button>
    //<div class="js_rnavi">表示切り替えエリア</div>
    //
    //クラス名がかぶらないよう、操作するクラスにつけるクラス名はルール化する
    //クラス名ルール例："js_"+"表示する内容を詳しく"
    $(function() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      $('.js_toggle_switch').click(function(event: any) {
        const js_disp_area = '.' + $(event.currentTarget).data('toggle');
        $(js_disp_area).toggleClass('is-visible');
      });
    });

    //モーダルに画像入れる
    //const modalWrapper = document.querySelector('.ui-modal');
    const images = document.querySelectorAll('.image');
    const modalImage = document.querySelector('.modal-image');

    images.forEach(function(image) {
      image.addEventListener('click', function() {
        //modalWrapper.classList.add('show');
        //modalImage.classList.add('show');

        const imageSrc = image.getAttribute('data-src');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (modalImage as any).src = imageSrc;
      });
    });

    //modalWrapper.addEventListener('click', function() {
    //     if (this.classList.contains('show')) {
    //          this.classList.remove('show');
    //         modalImage.classList.remove('show');
    //     }
    //});

    //scroll
    const Ease = {
      easeInOut: (t: number) =>
        t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
    };
    const duration = 500;
    const smoothScrollTriggers = document.querySelectorAll('a[href^="#"]');
    smoothScrollTriggers.forEach(function(smoothScrollTrigger) {
      smoothScrollTrigger.addEventListener('click', function(e: Event) {
        const href = smoothScrollTrigger.getAttribute('href');
        const currentPostion =
          document.documentElement.scrollTop || document.body.scrollTop;
        const targetElement = document.getElementById(
          (href as string).replace('#', '')
        );
        if (targetElement) {
          e.preventDefault();
          e.stopPropagation();
          const targetPosition =
            window.pageYOffset +
            targetElement.getBoundingClientRect().top -
            115;
          const startTime = performance.now();
          const loop = function(nowTime: number) {
            const time = nowTime - startTime;
            const normalizedTime = time / duration;
            if (normalizedTime < 1) {
              window.scrollTo(
                0,
                currentPostion +
                  (targetPosition - currentPostion) *
                    Ease.easeInOut(normalizedTime)
              );
              requestAnimationFrame(loop);
            } else {
              window.scrollTo(0, targetPosition);
            }
          };
          requestAnimationFrame(loop);
        }
      });
    });

    //スクロールして画面内に入ってきたらfadeinアニメーションクラスを付与
    const myFunc = function() {
      //Classを追加する要素を取得
      const target = document.getElementsByClassName('js-ui-animation-fadeup');
      //Classを追加する位置を指定（ビューポート内）
      const position = Math.floor(window.innerHeight * 0.85); //左記はビューポート内の上から85%の位置を指定

      //要素の数だけループする
      for (let i = 0; i < target.length; i++) {
        //要素の上部座標を取得する（小数点切り捨て）
        const offsetTop = Math.floor(target[i].getBoundingClientRect().top); //要素の上部座標がpositionの位置を通過したら
        if (offsetTop < position) {
          //要素にClassを追加する
          target[i].classList.add('ui-animation-fadeup');
        }
      }
    };
    //スクロールイベントリスナーに登録
    window.addEventListener('scroll', myFunc, false);

    return () => {
      window.removeEventListener('scroll', myFunc, false);
    };
  }, []);

  const isIE =
    (window.navigator.userAgent ?? '').toLowerCase().indexOf('trident') !== -1;

  const HeadBlockImg = 'https://tw.minkabu.jp/static/images/lp/lp_og_image.png';

  if (!notificationItems)
    return (
      <Loading
        loading={true}
        style={{
          backgroundColor: '#edf2f7',
          alignItems: 'normal',
          paddingTop: '200px',
          top: '95',
          left: '0',
        }}
      />
    );

  /* eslint-disable react/jsx-no-target-blank */
  return (
    <>
      <HeadBlock {...{ img: HeadBlockImg }} />
      <div
        className={['login relative', isShowSideMenu && 'md_drawerright_open']
          .filter(x => x)
          .join(' ')}
        id="layout">
        <header className="bg-white z-50 shadow-md sticky top-0" id="id_header">
          <nav className="container space-x-2 items-center ui-header lg:flex hidden">
            <div className="text-gray-700 text-center ui-header-logo">
              <a title="みんかぶ" href="https://minkabu.jp/">
                <img
                  src="https://assets.minkabu.jp/images/logo/v4/logo_minkabu.svg"
                  width="146"
                  height="40"
                  alt="みんかぶ"
                />
              </a>
            </div>
            <div className="ui-header-menu">
              <ul className="flex justify-start pl-7 relative">
                <li>
                  <a
                    className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                    href="https://minkabu.jp/">
                    株式
                  </a>
                </li>
                <li>
                  <a
                    className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                    href="https://us.minkabu.jp/">
                    米国株
                  </a>
                </li>
                <li>
                  <a
                    className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                    href="https://fx.minkabu.jp/">
                    FX/為替
                  </a>
                </li>
                <li>
                  <a
                    className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                    href="https://cc.minkabu.jp/">
                    仮想通貨
                  </a>
                </li>
                <li>
                  <a
                    className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                    href="https://itf.minkabu.jp/">
                    投信
                  </a>
                </li>
                <li>
                  <a
                    className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                    href="https://fu.minkabu.jp/">
                    先物
                  </a>
                </li>
                <li>
                  <a
                    className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                    href="https://ins.minkabu.jp/">
                    保険
                  </a>
                </li>
                <li>
                  <a
                    className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                    href="https://mag.minkabu.jp/">
                    初心者
                  </a>
                </li>
              </ul>
            </div>
            <div className="ui-header-button-wrapper flex justify-end">
              <div className="ui-header-button flex space-x-2 lg:text-sm text-xs">
                {isIE && (
                  <div className="text-sm text-gray-700">
                    Internet Explorerブラウザではご利用いただけません
                  </div>
                )}
                {!isIE && (
                  <>
                    <button
                      className="ui-button theme-normal w-1/2 login-exe"
                      id="click_login_header_login"
                      onClick={login}>
                      ログイン
                    </button>
                    <button
                      className="ui-button theme-sub w-1/2 register-exe"
                      id="click_login_header_register"
                      onClick={register}>
                      新規登録
                    </button>
                  </>
                )}
              </div>
            </div>
          </nav>
          <div className="ui-header-sp border-b border-gray-300 block lg:hidden">
            <nav className="flex p-2">
              <div className="flex-1 flex justify-start">
                <button className="flex items-center p-2 hidden">
                  <i className="icon-chevron-left text-2xl text-gray-700"></i>
                </button>
              </div>
              <div className="flex-grow flex justify-center items-center">
                <a title="みんかぶ" href="https://minkabu.jp/">
                  <img
                    src="https://assets.minkabu.jp/images/logo/v4/logo_minkabu.svg"
                    width="110"
                    height="30"
                    alt="みんかぶ"
                  />
                </a>
              </div>
              <div className="flex-1 flex justify-end">
                <section className="pl-4 pr-2 pt-2 ">
                  {!isApp && (
                    <div
                      className="btn-trigger "
                      id="btn01"
                      onClick={!isShowSideMenu ? menuShow : menuHideAnimate}>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  )}
                </section>
              </div>
            </nav>
          </div>
          <div className="w-full lg:block hidden bg-gray-800">
            <nav className="relative  shadow top-0 border-t-0 text-white container m-auto">
              <ul className="table table-fixed font-bold w-full">
                <li className="align-middle table-cell text-center hover:bg-white hover:bg-opacity-25">
                  <a
                    style={{ lineHeight: '50px' }}
                    className="inline-block w-full"
                    href="https://minkabu.jp/pick/balance/buy"
                    title="株価予想">
                    株価予想
                  </a>
                </li>
                <li className="align-middle table-cell text-center hover:bg-white hover:bg-opacity-25">
                  <a
                    style={{ lineHeight: '50px' }}
                    className="inline-block w-full"
                    href="https://minkabu.jp/financial_item_ranking"
                    title="株式ランキング">
                    株式ランキング
                  </a>
                </li>
                <li className="align-middle table-cell text-center hover:bg-white hover:bg-opacity-25">
                  <a
                    style={{ lineHeight: '50px' }}
                    className="inline-block w-full"
                    href="https://minkabu.jp/news"
                    title="ニュース">
                    ニュース
                  </a>
                </li>
                <li className="align-middle table-cell text-center hover:bg-white hover:bg-opacity-25">
                  <a
                    style={{ lineHeight: '50px' }}
                    className="inline-block w-full"
                    href="https://minkabu.jp/blog"
                    title="会員ブログ">
                    会員ブログ
                  </a>
                </li>
                <li className="align-middle table-cell text-center hover:bg-white hover:bg-opacity-25">
                  <a
                    style={{ lineHeight: '50px' }}
                    className="inline-block w-full"
                    href="https://minkabu.jp/beginner/"
                    title="株初心者入門">
                    株初心者入門
                  </a>
                </li>
                <li className="align-middle table-cell text-center hover:bg-white hover:bg-opacity-25 relative">
                  <a
                    style={{ lineHeight: '50px' }}
                    className="inline-block w-full"
                    href="https://tw.minkabu.jp/"
                    title="アセプラ（みんかぶアセットプランナー）へ">
                    アセプラで資産形成
                  </a>
                  <div className="h-1 bg-red-500 w-full absolute bottom-0"></div>
                </li>
              </ul>
            </nav>
          </div>
        </header>

        {isShowSideMenu && (
          <LoginSideMenu
            hideAnimate={hideAnimate}
            menuHide={menuHide}
            onNavLinkClick={(e: React.MouseEvent, path: string) => {
              return;
            }}
          />
        )}

        <div className="bg-gradient-b-bluegray">
          <div className="lg:flex container h-96 lg:px-4 lg:px-0  relative">
            <div className="lg:w-2/3 overflow-hidden relative">
              <img
                src="/static/images/lp/assetplanner_lp.png"
                alt="アセプラの画面イメージ"
                width="1560"
                height="1000"
                className="lg:absolute bottom-0 block ui-animation-slidein"
              />
              <img
                src="/static/images/lp/assetplanner_lp_parts3.png"
                alt="アセプラ機能3"
                style={{ top: '58%', left: '29%' }}
                className="w-lpImageSp lg:w-lpImagePc3 absolute ui-animation-popup-delay3"
              />
              <img
                src="/static/images/lp/assetplanner_lp_parts1.png"
                alt="アセプラ機能1"
                style={{ top: '39%', left: '47%' }}
                className="w-lpImageSp lg:w-lpImagePc2 absolute ui-animation-popup-delay2"
              />
              <img
                src="/static/images/lp/assetplanner_lp_parts2.png"
                alt="アセプラ機能2"
                style={{ top: '9%', left: '34%' }}
                className="w-lpImageSp lg:w-lpImagePc1 absolute ui-animation-popup-delay1"
              />
              <div
                className="bg-red-600 absolute font-bold text-white lg:text-2xl text-xl py-1 px-4"
                style={{ top: '70%', left: '0%' }}>
                投資で資産形成するなら、アセプラ
              </div>
            </div>
            <div className=" lg:w-1/3 lg:pt-8 z-10">
              <div className="text-white lg:rounded-lg lg:bg-none p-4 lg:bg-none lg:rounded-lg text-center">
                <h1 className="font-bold text-lg  py-2 text-center" id="top">
                  <span className="text-sm lg:text-sm block">
                    株式投資を分析する投資管理アプリ
                  </span>
                  <img
                    loading="lazy"
                    src="/static/images/lp/logo_minkabu_as_dark.svg"
                    alt="アセプラ（みんかぶアセットプランナー）ロゴ"
                    title="アセプラ（みんかぶアセットプランナー）ロゴ"
                    width="300"
                    height="82"
                    className="mx-auto py-2 w-2/3 lg:w-4/5"
                  />
                </h1>
                <div className="text-lg lg:block flex space-x-2 lg:space-x-0">
                  {isIE && (
                    <button className="w-full ui-button theme-sub mb-2 whitespace-no-wrap">
                      IEブラウザでは
                      <br />
                      ご利用いただけません
                    </button>
                  )}
                </div>
                <div className="text-lg lg:block flex space-x-2 lg:space-x-0">
                  {!isIE && (
                    <>
                      <button
                        className="lg:w-full w-1/2 ui-button mb-2 whitespace-no-wrap login-exe"
                        id="click_login_login"
                        onClick={isIosApp() ? loginFromIosApp : login}>
                        <div className="rounded-full px-3 bg-white text-blue text-xs w-32 m-auto">
                          みんかぶ会員の方
                        </div>
                        ログイン
                      </button>
                      <button
                        className="lg:w-full w-1/2 ui-button bg-gradient-r-orange mb-2 whitespace-no-wrap register-exe"
                        id="click_login_register"
                        onClick={isIosApp() ? registerFromIosApp : register}>
                        <div className="rounded-full px-2 bg-white text-orange text-xs w-32 m-auto">
                          初めてご利用の方
                        </div>
                        新規登録
                      </button>
                    </>
                  )}
                </div>
                {!isApp && (
                  <div className="block py-2 px-4 lg:mt-4 mb-2 bg-gray-500 text-white rounded-full text-center bg-opacity-75 font-bold text-sm">
                    初回登録30日間、無料キャンペーン中！
                  </div>
                )}
                <div className="text-left text-xs hidden lg:inline-block mt-4 text-gray-300">
                  <div className="font-bold text-center">推奨環境</div>
                  <span className="font-bold mr-2 inline-block">iOS</span>
                  Safari,Chrome 最新版 /{' '}
                  <span className="font-bold mr-2 inline-block">Android</span>
                  Chrome 最新版
                </div>
              </div>
            </div>
          </div>
          <div className="hidden lg:flex py-8 bg-gradient-b-deepBlueGray text-white hidden items-center justify-center lg-login-app-banner">
            <div className="flex items-end justify-between">
              <div className="">
                <div className="text-lg font-bold text-center leading-6 mb-8">
                  ＼ アセプラのアプリを無料でダウンロード ／
                </div>
                <ul className="flex justify-center items-center px-2">
                  <li
                    className="cursor-pointer hover:opacity-75 active:opacity-75"
                    id="click_login_download_application">
                    <a
                      href="https://play.google.com/store/apps/details?id=jp.minkabu.ap"
                      target="_blank"
                      rel="noopener">
                      <img
                        src="/static/images/lp/google-play-badge.svg"
                        width="174"
                        alt="badge"
                        height="50"
                      />
                    </a>
                  </li>
                </ul>
              </div>
              <div className="ml-8">
                <ul className="flex items-end">
                  <li className="flex items-center flex-col justify-end">
                    <div className="text-sm text-center leading-5">Android</div>
                    <div className="rounded p-1 bg-white">
                      <img
                        src="/static/images/lp/map-googleplay.svg"
                        alt="map"
                        width="80"
                        height="80"
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {!isApp && (
          <>
            <div className="container rounded bg-white shadow-md z-20 lg:mb-8 mb-3">
              <nav className="flex justify-between text-gray-700 container lg:px-4 px-2 lg:w-2/3 m-auto py-1 lg:text-lg font-bold">
                <a
                  href="#overview"
                  className="lg:flex hover:text-gray-500 relative text-center py-4">
                  <i
                    className="icon-twinkle text-2xl px-2 text-red"
                    title="アセプラとは"></i>
                  <p className="text-sm  lg:text-lg">アセプラとは</p>
                </a>
                <a
                  href="#product"
                  className="lg:flex hover:text-gray-500 relative text-center py-4">
                  {/* <span className="absolute right-0 flex rounded-full bg-teal Z-10 px-1 text-2xs text-white">3</span> */}
                  <i
                    className="icon-award text-2xl px-2 text-red"
                    title="アセプラ機能説明"></i>
                  <p className="text-sm lg:text-lg">機能説明</p>
                </a>

                <a
                  href="#value"
                  className="lg:flex hover:text-gray-500 relative text-center py-4">
                  <i
                    className="icon-credit-card text-2xl px-2  text-red"
                    title="アセプラ利用料金"></i>
                  <p className="text-sm lg:text-lg">利用料金</p>
                </a>

                <a
                  href="#security"
                  className="lg:flex hover:text-gray-500 relative text-center py-4">
                  <i
                    className="icon-verified_user text-2xl px-2 text-red"
                    title="アセプラのセキュリティ"></i>
                  <p className="text-sm lg:text-lg">セキュリティ</p>
                </a>
              </nav>
            </div>

            <div className="lg:flex hidden items-center justify-center mb-8">
              <a href="#dividend">
                <img
                  src="/static/images/lp/dividend_banner_pc_ph2.svg"
                  alt="配当金バナー"
                  className=""
                />
              </a>
            </div>
            <div className="flex lg:hidden items-center justify-center mb-3">
              <a href="#dividend">
                <img
                  src="/static/images/lp/dividend_banner_sp_ph2.svg"
                  alt="配当金バナー"
                  className=""
                />
              </a>
            </div>

            {/* <div className="container mb-16 px-2 text-center">
        <div className="block py-2 px-4 lg:mt-4 bg-gray-800 text-white rounded inline-block m-auto lg:w-2/3 shadow-md">
          <div className="lg:flex justify-center lg:space-x-4">
            <div className="lg:w-3/4">
              <span className="font-bold text-lg flex justify-center py-2">
                <div className="relative ui-animation-tada">
                  <i className="icon-celebration text-xl"></i>
                </div>
                &nbsp;テレビCM公開決定！
              </span>
              BSテレ東「マネーのまなび」
              <span className="text-sm">(毎週木曜22:00〜)</span>
              <br />
              2021年10月7日放送回より
            </div>
            <div className="lg:w-1/4 w-2/3 m-auto py-2">
              <img
                loading="lazy"
                src="/static/images/lp/cm.png"
                alt="アセプラCMイメージ"
                width="300"
                height="200"
                className="w-full border-white border rounded"
              />
            </div>
          </div>
        </div>
      </div> */}

            {notificationItems.length === 0 ? (
              <></>
            ) : (
              <LoginNotification {...{ notificationItems }} />
            )}
            <section className="container px-2 mb-16 lg:px-4">
              <div className="text-center mb-8">
                <h2
                  id="overview"
                  className="text-xl font-bold mb-2 lg:text-3xl lg:mb-4">
                  アセプラ(みんかぶアセットプランナー)とは？
                </h2>
                <div className="h-4 w-64 bg-red-500 right-half mx-auto"></div>
              </div>
              <div className="text-center mb-4">
                <h3 id="overview_lead" className="text-xl font-bold">
                  複数口座の投資をまとめて管理
                  <br />
                  チャートで資産推移がわかる
                </h3>
              </div>
              <p className="text-base text-center leading-7 mb-16 lb:mb-12">
                みんかぶアセットプランナー（アセプラ）は、個人投資家の資産形成をサポートする投資管理アプリです。
                <br />
                複数の証券口座にある資産をチャート・グラフ化し、資産形成を成功に導きます。
              </p>

              <div className="mb-8">
                <div className="flex flex-col bg-white border border-solid rounded-lg shadow-panel px-8 py-8 mb-4 lg:p-8 lg:mb-8 lg:mx-24 lg:flex-row lg:max-w-864p lg:mx-auto">
                  <div className="lg:mr-4 lg:w-300p">
                    <img
                      src="/static/images/lp/merit_img_1.png"
                      alt="merit1"
                      width="300"
                      height="240"
                      className="w-full"
                    />
                  </div>
                  <div className="flex-1">
                    <h4 className="mt-4 mb-2 text-xl font-bold leading-8">
                      あなたの資産の推移が
                      <br />
                      1分でわかる
                    </h4>
                    <div className="text-base leading-7">
                      複数口座にある資産をまとめて管理。
                      <br />
                      株式の取引履歴や資産推移をチャートやポートフォリオで分かりやすく表示します。複数の株アプリを見なくても、保有銘柄の損益がひと目で分かります。
                    </div>
                  </div>
                </div>
                <div className="flex flex-col bg-white border border-solid rounded-lg shadow-panel px-8 py-8 mb-4 lg:mb-4 lg:p-8 lg:mb-8 lg:mx-24 lg:flex-row lg:max-w-864p lg:mx-auto">
                  <div className="flex-1">
                    <div className="lg:hidden">
                      <img
                        src="/static/images/lp/merit_img_2.png"
                        alt="merit2"
                        width="300"
                        height="240"
                        className="w-full"
                      />
                    </div>
                    <h4 className="mt-4 mb-2 text-xl font-bold leading-8">
                      老後資金など
                      <br />
                      目的ごとに資産の増やし方を提案
                    </h4>
                    <div className="text-base leading-7">
                      「老後に向けて資産を運用したい」「教育資金を計画的に運用したい」など、目的ごとに株式や投資信託を管理・分析し、あなたの目標にあった資産の増やし方を提案します。
                    </div>
                  </div>
                  <div className="ml-4 hidden lg:block lg:w-300p">
                    <img
                      src="/static/images/lp/merit_img_2.png"
                      alt="merit2"
                      width="300"
                      height="240"
                      className="w-full"
                    />
                  </div>
                </div>
                <div className="flex flex-col bg-white border border-solid rounded-lg shadow-panel px-8 py-8 mb-4 lg:p-8 lg:mb-2 lg:mx-24 lg:flex-row lg:max-w-864p lg:mx-auto">
                  <div className="lg:mr-6 lg:w-300p">
                    <img
                      src="/static/images/lp/merit_img_3.png"
                      alt="merit3"
                      width="300"
                      height="240"
                      className="w-full"
                    />
                  </div>
                  <div className="flex-1">
                    <h4 className="mt-4 mb-2 text-xl font-bold leading-8">
                      LINEに最新の資産を毎日レポート
                      <br />
                      忙しいあなたも安心
                    </h4>
                    <div className="text-base leading-7">
                      LINEに最新の資産情報を毎日レポート。週・月単位の資産変動もわかります。
                      <br />
                      週ごと、月ごとの資産推移をチャートで見たり、保有銘柄ごとに損益の推移を管理できます。
                    </div>
                  </div>
                </div>
                <div className="leading-7 text-sm text-center text-gray-500">
                  ※一部プレミアム会員の方限定のサービスになります。
                </div>
              </div>
            </section>
            <section>
              {/* PC */}
              <div className="hidden lg:flex py-20 px-24 text-white bg-gray-800">
                <div
                  className="grid"
                  style={{ gridTemplateColumns: '1fr 1fr' }}>
                  <div className="px-4">
                    <div className="">
                      <img
                        src="/static/images/lp/title_ribbon.png"
                        alt="資産形成のコツ"
                        className=""
                      />
                    </div>
                    <div className="text-2xl font-bold text-center">
                      何となく貯金してませんか？
                    </div>
                    <div className="mt-4 text-base">
                      お金は「目的別に見える化」することが大切。
                      <br />
                      あといくら貯めるのか明確になり、不安やムダがなくなります。アセプラを使って資産の「見える化」はじめましょう！
                    </div>
                    <div className="flex justify-center">
                      <img
                        src="/static/images/lp/sisanseikei_img.png"
                        alt="資産形成のコツ"
                        className="mt-4"
                        width="169"
                        height="128"
                      />
                    </div>
                  </div>
                  <div className="px-4 w-full h-72 min-h-full">
                    <iframe
                      width="100%"
                      height="100%"
                      src="https://www.youtube.com/embed/c15FmbOB_14"
                      title="YouTube video player"
                      className=""
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
                  </div>
                </div>
              </div>
              {/* SP */}
              <div className="flex lg:hidden flex-col px-4 pt-20 pb-16 text-white bg-gray-800">
                <div className="">
                  <img
                    src="/static/images/lp/title_ribbon.png"
                    alt="資産形成のコツ"
                    className=""
                  />
                </div>
                <div className="mt-2 text-2xl text-center">
                  何となく貯金してませんか？
                </div>
                <div className="mt-2 mb-4 text-base">
                  お金は「目的別に見える化」することが大切。
                  そうすることで目的のために、あといくら貯めないといけないのかを明確になり、不安やムダがなくなります。
                </div>
                {/* backlogからコピペしてるけどエラーになる部分は削除してる。 */}
                <div className="w-full h-72 min-h-full">
                  <iframe
                    width="100%"
                    height="100%"
                    src="https://www.youtube.com/embed/c15FmbOB_14"
                    title="YouTube video player"
                    className=""
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
                </div>
              </div>
            </section>
            <section className="bg-white flex items-center flex-col p-8 lg:p-12 ">
              <h2 className="text-xl font-bold text-center leading-8 mb-8 lg:mb-4 lg:text-2xl">
                アセプラの利用方法
              </h2>
              <ul className="lg:flex justify-center lg:text-2xl lg:leading-8 mb-12">
                <li className="border border-solid flex flex-col items-center rounded-lg px-4 py-8 mb-4 max-w-panel-m lg:mb-0">
                  <div className="text-center font-bold mb-2 text-orange-asset">
                    STEP１
                  </div>
                  <div className="text-center font-bold text-base leading-7">
                    みんかぶ会員登録
                  </div>
                  <img
                    src="/static/images/lp/asset_step1.png"
                    alt="step1"
                    width="300"
                    height="240"
                    className="m-4"
                  />
                  <div className="px-3.5 max-w-btn-m h-7 rounded-btn-m mb-4 flex items-center justify-center bg-orange-100">
                    <img
                      src="/static/images/lp/clock_img.svg"
                      alt="clock"
                      width="18"
                      height="18"
                      className="w-4.5 h-4.5"
                    />
                    <div className="text-center font-bold text-sm w-20 text-white leading-7">
                      約３分
                    </div>
                  </div>
                  <div className="text-base mb-4 text-left leading-6">
                    <div className="">
                      「みんかぶ会員登録」で登録手続きを行なってください。
                    </div>
                    <div className="opacity-75">
                      ※すでにみんかぶ会員の方はこの手続きは必要ありません
                    </div>
                  </div>
                  <div className="text-base text-link leading-6 flex justify-center items-center cursor-pointer">
                    みんかぶ会員登録はこちら
                  </div>
                </li>
                <li className="border border-solid flex flex-col items-center rounded-lg px-4 py-8 mb-4 max-w-panel-m lg:mb-0 lg:ml-8">
                  <div className="text-center font-bold mb-2 text-orange-asset">
                    STEP2
                  </div>
                  <div className="text-center font-bold text-base leading-7">
                    お手持ちの口座と連携
                  </div>
                  <img
                    src="/static/images/lp/asset_step2.png"
                    alt="step2"
                    width="300"
                    height="240"
                    className="m-4"
                  />
                  <div className="px-3.5 max-w-btn-m h-7 rounded-btn-m mb-4 flex items-center justify-center bg-orange-100">
                    <img
                      src="/static/images/lp/clock_img.svg"
                      alt="clock"
                      width="18"
                      height="18"
                      className="w-4.5 h-4.5"
                    />
                    <div className="text-center font-bold text-sm w-20 text-white leading-7">
                      最短１分
                    </div>
                  </div>
                  <div className="text-base mb-4 text-left leading-6">
                    <div className="">
                      お手持ちの口座のID（ユーザーネーム・口座番号）・パスワードを入力するだけでアセプラと連携できます。
                    </div>
                  </div>
                </li>
                <li className="border border-solid flex flex-col items-center rounded-lg px-4 py-8 mb-4 max-w-panel-m lg:mb-0 lg:ml-8">
                  <div className="text-center font-bold mb-2 text-orange-asset">
                    STEP3
                  </div>
                  <div className="text-center font-bold text-base leading-7">
                    連携した口座の資産がまとめて見れる
                  </div>
                  <img
                    src="/static/images/lp/asset_step3.png"
                    alt="step3"
                    width="300"
                    height="240"
                    className="m-4"
                  />
                  <div className="px-3.5 max-w-btn-m h-7 rounded-btn-m mb-4 flex items-center justify-center bg-orange-100">
                    <img
                      src="/static/images/lp/clock_img.svg"
                      alt="clock"
                      width="18"
                      height="18"
                      className="w-4.5 h-4.5"
                    />
                    <div className="text-center font-bold text-sm w-20 text-white leading-7">
                      ５分〜10分
                    </div>
                  </div>
                  <div className="text-base mb-4 text-left leading-6">
                    <div className="">
                      連携口座一覧に連携した口座が追加されていたら完了です。連携した口座の内容がチャートなどに反映されます。
                    </div>
                    <div className="opacity-75">
                      ※データの反映まで時間がかかる場合があります。
                    </div>
                  </div>
                </li>
              </ul>
              <div
                className="bg-gradient-to-r bg-gradient-r-red flex justify-center text-center w-full max-w-btn-l py-4 text-white text-2xl font-bold leading-9 rounded-lg mb-4 cursor-pointer hover:opacity-75"
                id="click_login_start_asset_planner"
                onClick={register}>
                アセプラを始めてみる
              </div>
              <div
                className="mb-12 leading-9 text-lg text-link flex justify-center items-center cursor-pointer"
                onClick={login}>
                すでにみんかぶ会員の方はこちら
              </div>
              <div className="bg-white border rounded-lg max-w-3xl w-full py-6 px-2 mb-4 lg:p-9 lg:px-16">
                <div className="flex items-center justify-center login-app-banner">
                  <div className="flex justify-center w-full">
                    <div className="flex flex-col justify-end max-w-375p">
                      <div className="flex items-end justify-between mb-6 lg:mb-auto app-primary-label-block">
                        <div className="inline-flex items-center flex-col lg:flex-row text-bluegray-700 font-bold">
                          <span className="lg:hidden">アセプラのアプリを</span>
                          <span className="lg:hidden">無料でダウンロード</span>
                          <span className="hidden lg:block">
                            アセプラの無料アプリは
                          </span>
                          <span className="hidden lg:block">こちらから</span>
                        </div>
                      </div>
                      <ul className="flex justify-center items-center">
                        <li className="cursor-pointer hover:opacity-75 active:opacity-75">
                          <a
                            href="https://play.google.com/store/apps/details?id=jp.minkabu.ap"
                            target="_blank"
                            rel="noopener">
                            <img
                              src="/static/images/lp/google-play-badge.svg"
                              alt="badge"
                              width="174"
                              height="50"
                            />
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="hidden lg:flex">
                      <ul className="flex">
                        <li className="ml-8">
                          <div
                            className="text-sm
                          text-bluegray-500
                          text-center
                          leading-5
                          mb-1">
                            Android
                          </div>
                          <div className="rounded p-1 bg-white">
                            <img
                              src="/static/images/lp/map-googleplay.svg"
                              alt="map"
                              width="80"
                              height="80"
                            />
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="container px-2 mb-16 pt-16 js-ui-animation-fadeup lg:px-4">
              {/*アセプラの機能紹介*/}
              <div className="text-center mb-8">
                <div id="shisan" ref={reportShisan} />
                <h2 id="product" className="lg:text-3xl text-xl font-bold mb-2">
                  アセプラの機能紹介
                </h2>
                <div className="h-4 w-64 bg-red-500 right-half mx-auto"></div>
              </div>
              {/*1分でわかるあなたの資産状況*/}
              <div className="bg-white border rounded-lg shadow-panel py-12 px-4 mb-8 lg:px-4">
                <div className="flex flex-col items-center text-center border-b mb-8">
                  <h3 className="text-2xl text-sky-500 font-bold leading-9 mb-12">
                    1分でわかるあなたの資産状況
                  </h3>
                  <div className="flex justify-center items-center justify-center flex-col border bg-gray-100 rounded-lg max-w-776p mb-8 relative lg:flex-row">
                    <div className="flex items-center mb-6 absolute bubble-border-block max-w-80 w-full lg:max-w-bubble lg:bubble-border-block">
                      <h4
                        id="shisan_q"
                        className="ui-heading ui-bubble-border bg-white border-gray-500 border-3 h-full flex items-center justify-center py-2 px-6 rounded-full text-bluegray-700 text-center w-full">
                        増えてる？減ってる？資産の推移がわかりづらい
                      </h4>
                    </div>
                    <div className="flex justify-center items-center flex-col w-full px-8 pt-18 pb-4 lg:flex-row lg:justify-between lg:pt-14 lg:px-8">
                      <div className="mb-4 lg:mb-0 lg:w-320p">
                        <img
                          loading="lazy"
                          src="/static/images/lp/aruaru_shisan.png"
                          alt=""
                          width="320"
                          height="160"
                          className="w-full"
                        />
                      </div>
                      <div className="">
                        <div className="text-base leading-7">
                          この口座では増えてて、この口座では減ってて・・・
                          <br />
                          証券口座をいくつも持っていると、
                          <br />
                          資産の増減がわかりづらいなぁ。
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-center js-ui-animation-fadeup">
                  <i className="icon-chevron-down text-3xl px-2 text-bluegray-500"></i>
                </div>
                <div className=" lg:space-x-4 pl-4 py-4 mb-4 text-center">
                  <h4 id="shisan_a" className="ui-heading mb-4">
                    資産を一元管理、直感的にわかりやすいチャート機能
                  </h4>
                  <div className="lg:text-center text-left leading-7 mb-4">
                    <div className="font-bold text-base mb-2">
                      資産の見える化は資産形成の第一歩。
                    </div>
                    アセプラでは複数の証券口座の資産推移をアプリで一元管理できます。
                    <br />
                    資産総額の推移、損益推移、資産比率など見やすいチャートで表示、一目で確認できます。
                  </div>
                  <p className="mb-4">
                    <a
                      href="#data"
                      className="text-sm text-link flex justify-center items-center cursor-pointer">
                      <span>連携が可能な証券会社</span>
                    </a>
                  </p>
                </div>
                <div className="lg:flex justify-center p-4 mb-4">
                  <div className="lg:w-1/4">
                    <h5 id="shisan_chart" className="font-bold text-lg">
                      資産管理チャート
                    </h5>
                    <p className="leading-7 mb-2">
                      複数の証券口座や銀行口座の資産をまとめて1つのチャートで確認できます。資産推移、損益推移など多様なチャートをご用意しています。
                    </p>
                  </div>
                  <div className="lg:w-3/4">
                    <div className="ui-horizontal-scroll lg:flex justify-center lg:space-x-4 overflow-hidden">
                      <div className="ui-horizontal-scroll-item lg:w-1/4  h-56 lg:h-20 w-screen-60">
                        <img
                          loading="lazy"
                          src="/static/images/lp/home_shisan.png"
                          alt="資産推移チャート"
                          width="340"
                          height="626"
                          className=" js_toggle_switch image"
                          data-toggle="js_modal"
                          data-src="static/images/lp/home_shisan.png"
                        />
                      </div>
                      <div className="ui-horizontal-scroll-item lg:w-1/4  h-56 lg:h-20 w-screen-60">
                        <img
                          loading="lazy"
                          src="/static/images/lp/home_soneki.png"
                          alt="損益チャート"
                          width="340"
                          height="626"
                          className=" js_toggle_switch image"
                          data-toggle="js_modal"
                          data-src="static/images/lp/home_soneki.png"
                        />
                      </div>
                      <div className="ui-horizontal-scroll-item lg:w-1/4  h-56 lg:h-20 w-screen-60">
                        <img
                          loading="lazy"
                          src="/static/images/lp/home_uchiwake.png"
                          alt="内訳チャート"
                          width="340"
                          height="626"
                          className=" js_toggle_switch image"
                          data-toggle="js_modal"
                          data-src="static/images/lp/home_uchiwake.png"
                        />
                      </div>
                      <div className="ui-horizontal-scroll-item lg:w-1/4  h-56 lg:h-20 w-screen-60">
                        <img
                          loading="lazy"
                          src="/static/images/lp/home_hiritsu.png"
                          alt="比率チャート"
                          width="340"
                          height="626"
                          className=" js_toggle_switch image"
                          data-toggle="js_modal"
                          data-src="static/images/lp/home_hiritsu.png"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/*マネーツリー連携でより正確に管理*/}
                <div className="bg-teal-pale rounded-lg text-center p-4 mb-8">
                  <h4
                    id="shisan_moneytree"
                    className="text-lg font-bold lg:text-center mb-2">
                    家計簿アプリ「マネーツリー」連携で銀行口座の資産も管理
                  </h4>
                  <div className="lg:text-center text-left leading-6">
                    マネーツリー連携することで、証券会社以外の金融資産（銀行,クレジットカード、電子マネーなど）を管理することができます。
                    <br />
                    証券口座の資産変動や、銀行口座の入出金履歴など、アセプラで「資産の見える化」をしましょう。
                  </div>
                </div>
                <div
                  className="flex justify-center items-center font-bold text-xl lg:text-2xl text-tradewell border border-tradewell rounded-lg max-w-btn-l mx-auto h-16 cursor-pointer"
                  id="click_login_start_chart"
                  onClick={() => (isMinkabuMember ? login() : register())}>
                  資産をチャートで見てみる
                </div>
              </div>

              {/*売買したタイミングがわかる取引履歴*/}
              <div className="bg-white border rounded-lg shadow-panel py-12 px-6 mb-8 lg:px-6">
                <div className="flex flex-col items-center text-center border-b mb-8">
                  <h3
                    id="rireki"
                    className="text-2xl text-sky-500 font-bold leading-9 mb-12">
                    売買したタイミングがわかる取引履歴
                  </h3>
                  <div className="flex justify-center items-center justify-center flex-col border bg-gray-100 rounded-lg w-full max-w-776p mb-8 relative lg:flex-row">
                    <div className="flex items-center mb-6 absolute bubble-border-block max-w-80 w-full lg:max-w-bubble lg:bubble-border-block">
                      <h4
                        id="shisan_q"
                        className="ui-heading ui-bubble-border bg-white
                    border-gray-500 border-3 h-full flex items-center justify-center py-2 px-6 rounded-full text-bluegray-700 text-center w-full">
                        いつも売買タイミングを見誤ってしまう
                      </h4>
                    </div>
                    <div className="flex justify-center items-center flex-col w-full px-8 pt-18 pb-4 lg:flex-row lg:justify-between lg:pt-14 lg:px-8">
                      <div className="mb-4 lg:mb-0 lg:w-320p">
                        <img
                          loading="lazy"
                          src="/static/images/lp/aruaru_timing.png"
                          alt="売買したタイミングがわかる取引履歴"
                          width="320"
                          height="160"
                          className=""
                        />
                      </div>
                      <div className="flex-1 text-base leading-7">
                        売ったら上がる、買ったら下がる・・。
                        <br />
                        売買タイミングを見抜けるようになりたい！
                      </div>
                    </div>
                  </div>
                </div>

                <div className="text-center js-ui-animation-fadeup ui-animation-fadeup mb-4">
                  <i className="icon-chevron-down text-3xl text-bluegray-500"></i>
                </div>
                <div className="mb-12 lg:mb-4 lg:space-x-4">
                  <h4
                    id="rireki_a"
                    className="font-bold text-lg mb-4 lg:text-center">
                    株式、投資信託の取引履歴を分析し、自分の投資傾向をつかむ
                  </h4>
                  <p className="leading-relax text-left lg:text-center lg:mb-12">
                    アセプラでは
                    <span className="font-bold">
                      株価チャート上に保有銘柄の取引履歴をプロットし、株式投資や投資信託のチャートを分析することができます。
                    </span>
                    <br />
                    自分がどのような場面で売買をしているか、自分の投資の傾向を知りたい投資家におすすめです。
                  </p>
                </div>
                <div className="mb-12 lg:flex">
                  <div className="relative visible flex-1">
                    <div className="p-4 justify-center lg:flex lg:p-0">
                      <div className="mb-4 flex-1 lg:mb-0">
                        <h5 id="shisan_chart" className="font-bold text-lg">
                          取引履歴チャート
                        </h5>
                        <p className=" leading-relax mb-2">
                          これまでの保有銘柄の取引タイミングを株価チャートで確認することで、自分の取引のクセに気づくことができます。
                        </p>
                      </div>
                      <div className="flex-1">
                        <div className="flex justify-center h-56 overflow-hidden relative lg:h-20">
                          <img
                            loading="lazy"
                            src="/static/images/lp/meigarapage.png"
                            alt="銘柄ページ"
                            width="340"
                            height="626"
                            className=" js_toggle_switch image bottom-0 absolute"
                            data-toggle="js_modal"
                            data-src="static/images/lp/meigarapage.png"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="relative visible flex-1 lg:ml-4">
                    <div className="p-4 justify-center lg:flex lg:p-0">
                      <div className="mb-4 flex-1 lg:mb-0">
                        <h5 id="shisan_list" className="font-bold text-lg">
                          取引履歴
                        </h5>
                        <p className=" leading-relax mb-2">
                          取引履歴を期間や取引ごと（株式・投資信託）、証券会社で絞り込み、それぞれの合計損益を計算することもできます。保有銘柄の運用成果を確認したい時に便利です。
                        </p>
                      </div>
                      <div className="flex-1">
                        <div className="flex justify-center h-56 overflow-hidden relative lg:h-20">
                          <img
                            loading="lazy"
                            src="/static/images/lp/torihikirireki.png"
                            alt="取引履歴"
                            width="340"
                            height="626"
                            className=" js_toggle_switch image top-0 absolute"
                            data-toggle="js_modal"
                            data-src="static/images/lp/torihikirireki.png"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="flex justify-center items-center font-bold text-xl text-tradewell border border-tradewell rounded-lg max-w-btn-l mx-auto h-16 lg:text-2xl cursor-pointer"
                  id="click_login_start_trade_history"
                  onClick={() =>
                    isMinkabuMember ? loginTrade() : registerTrade()
                  }>
                  取引履歴機能を使ってみる
                  <div id="report" ref={reportScroll} />
                </div>
              </div>

              {/*あなたの資産を分析　改善に向けたレポート*/}
              <div className="bg-white border rounded-lg shadow-panel py-12 px-6 mb-8 lg:px-6">
                <div className="flex flex-col items-center text-center border-b mb-8">
                  <h3 className="text-2xl text-sky-500 font-bold leading-9 mb-12">
                    LINEで投資の損益がわかる
                  </h3>
                  <div className="flex justify-center items-center justify-center flex-col border bg-gray-100 rounded-lg w-full max-w-776p mb-8 relative lg:flex-row">
                    <div className="flex items-center mb-6 absolute bubble-border-block max-w-80 w-full lg:max-w-bubble lg:bubble-border-block">
                      <h4
                        id="report_q"
                        className="ui-heading ui-bubble-border bg-white
                    border-gray-500 border-3 h-full flex items-center justify-center py-2 px-6 rounded-full text-bluegray-700 text-center w-full">
                        毎日資産状況を確認しておけばよかった・・・
                      </h4>
                    </div>
                    <div className="flex justify-center items-center flex-col w-full px-8 pt-18 pb-4 lg:flex-row lg:justify-between lg:pt-14 lg:px-8">
                      <div className="mb-4 lg:mb-0 lg:w-320p">
                        <img
                          loading="lazy"
                          src="/static/images/lp/aruaru_report.png"
                          alt="改善に向けたレポート"
                          width="320"
                          height="160"
                        />
                      </div>
                      <div className="flex-1 text-base leading-7">
                        しばらく資産状況を見ていなかったら、後の祭り。
                        <br />
                        せっかくの売買タイミングを逃してしまった。
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-center js-ui-animation-fadeup ui-animation-fadeup mb-4">
                  <i className="icon-chevron-down text-3xl text-bluegray-500"></i>
                </div>
                <div className="mb-12 lg:mb-4 lg:space-x-4">
                  <h4
                    id="report_a"
                    className="font-bold text-lg mb-4 lg:text-center">
                    最新の資産情報がわかる毎日のレポート
                  </h4>
                  <p className="leading-relax text-left lg:text-center lg:mb-12">
                    <span className="font-bold">
                      毎日夕方(※)に、株式・投資信託の損益をわかりやすくグラフにしたレポートをお届けします。
                    </span>
                    <br />
                    複数の証券口座にある資産の推移もアプリ1つで管理できます。
                    <br />
                    <span className="text-sm text-gray-500">※土日祝日除く</span>
                  </p>
                </div>
                <div className="mb-12 lg:flex lg:space-x-4">
                  <div className="mb-4 lg:w-1/2 lg:mb-0">
                    <h5 id="report_detaile" className="font-bold text-lg">
                      日次・週次・月次で資産推移を確認できるレポート
                    </h5>
                    <p className="mb-2 leading-relax">
                      保有銘柄ごとの損益や証券口座ごとの資産変動をまとめて管理できます。
                      <br />
                      レポートは日ごと、週ごと、月ごとに配信されるため、忙しい投資家の資産管理にピッタリです。
                    </p>
                  </div>
                  <div className="lg:w-1/2 flex">
                    <div className="ui-horizontal-scroll lg:flex justify-center lg:space-x-4 overflow-hidden">
                      {/* <div className="ui-horizontal-scroll-item lg:w-1/3 h-56 lg:h-20 w-screen-60 overflow-hidden">
                      <img
                        loading="lazy"
                        src="/static/images/lp/report_img_1.png"
                        alt="レポート機能"
                        width="191"
                        height="353"
                        className=" js_toggle_switch image"
                        data-toggle="js_modal"
                        data-src="static/images/lp/report_img_1.png"
                      />
                    </div> */}
                      <div className="ui-horizontal-scroll-item lg:w-1/2 h-56 lg:h-20 w-screen-60 overflow-hidden">
                        <img
                          loading="lazy"
                          src="/static/images/lp/report_img_2.png"
                          alt="レポート機能"
                          width="191"
                          height="353"
                          className=" js_toggle_switch image"
                          data-toggle="js_modal"
                          data-src="static/images/lp/report_img_2.png"
                        />
                      </div>
                      <div className="ui-horizontal-scroll-item lg:w-1/2 h-56 lg:h-20 w-screen-60 overflow-hidden">
                        <img
                          loading="lazy"
                          src="/static/images/lp/report_img_3.png"
                          alt="レポート機能"
                          width="191"
                          height="353"
                          className=" js_toggle_switch image"
                          data-toggle="js_modal"
                          data-src="static/images/lp/report_img_3.png"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="flex justify-center items-center font-bold text-xl text-tradewell border border-tradewell rounded-lg max-w-btn-l mx-auto h-16 lg:text-2xl cursor-pointer"
                  id="click_login_start_report"
                  onClick={() =>
                    isMinkabuMember ? loginReport() : registerReport()
                  }>
                  レポート機能を使ってみる
                </div>
              </div>

              {/*保有している銘柄情報の通知*/}
              <div className="bg-white border rounded-lg shadow-panel py-12 px-6 mb-8 lg:px-6">
                <div className="flex flex-col items-center text-center border-b mb-8">
                  <h3 className="text-2xl text-sky-500 font-bold leading-9 mb-12">
                    保有している銘柄情報の通知
                  </h3>
                  <div className="flex justify-center items-center justify-center flex-col border bg-gray-100 rounded-lg w-full max-w-776p mb-8 relative lg:flex-row">
                    <div className="flex items-center mb-6 absolute bubble-border-block max-w-80 w-full lg:max-w-bubble lg:bubble-border-block">
                      <h4
                        id="shisan_q"
                        className="ui-heading ui-bubble-border bg-white
                    border-gray-500 border-3 h-full flex items-center justify-center py-2 px-6 rounded-full text-bluegray-700 text-center w-full">
                        いつも大事な適時開示を見逃しちゃう
                      </h4>
                    </div>
                    <div className="flex justify-center items-center flex-col w-full px-8 pt-18 pb-4 lg:flex-row lg:justify-between lg:pt-14 lg:px-8">
                      <div className="mb-4 lg:mb-0 lg:w-320p">
                        <img
                          loading="lazy"
                          src="/static/images/lp/aruaru_brand.png"
                          alt=""
                          width="320"
                          height="160"
                          className=""
                        />
                      </div>
                      <div className="flex-1 text-base leading-7">
                        もっと早く気がついていれば・・
                        <br />
                        保有している銘柄に大事な発表があったみたい。
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-center js-ui-animation-fadeup ui-animation-fadeup mb-4">
                  <i className="icon-chevron-down text-3xl text-bluegray-500"></i>
                </div>
                <div className="mb-12 lg:flex lg:space-x-4">
                  <div className="lg:flex justify-center lg:space-x-4 w-full lg:w-2/3 m-auto">
                    <div className="mb-4 lg:w-2/3 lg:mb-0">
                      <h5 id="alert_a" className="font-bold text-lg">
                        保有銘柄の通知機能
                      </h5>
                      <p className="mb-2 leading-relax">
                        あなたの保有銘柄の適時開示情報をお知らせします。
                        <br />
                        こまめにチェックして、チャンスを逃さないようにしましょう。
                      </p>
                      <p className="text-sm text-gray-500">
                        <i className="icon-info mr-2"></i>
                        カスタマイズ機能を今後リリース予定です。画面イメージは変更となる可能性があります。
                      </p>
                    </div>
                    <div className="lg:w-1/3">
                      <div className="flex justify-center h-56 overflow-hidden relative lg:h-20">
                        <img
                          loading="lazy"
                          src="/static/images/lp/oshirase.png"
                          alt="適時開示"
                          width="340"
                          height="626"
                          className="js_toggle_switch image top-0 absolute"
                          data-toggle="js_modal"
                          data-src="static/images/lp/oshirase.png"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="flex justify-center items-center font-bold text-xl text-tradewell border border-tradewell rounded-lg max-w-btn-l mx-auto h-16 lg:text-2xl cursor-pointer"
                  id="click_login_start_notice"
                  onClick={() =>
                    isMinkabuMember
                      ? loginNotifiationSetting()
                      : registerNotifiationSetting()
                  }>
                  通知機能を使ってみる
                </div>
                <div id="target" ref={scroll} />
              </div>

              {/*資産目標達成へ近づける　資産目標サポート*/}
              <div className="bg-white border rounded-lg shadow-panel py-12 px-6 mb-8 lg:px-6">
                <div className="flex flex-col items-center text-center border-b mb-8">
                  <h3 className="text-2xl text-sky-500 font-bold leading-9 mb-12">
                    目標ごとにお金の増やし方がわかる 資産目標サポート
                  </h3>
                  <div className="flex justify-center items-center justify-center flex-col border bg-gray-100 rounded-lg w-full max-w-776p mb-8 relative lg:flex-row">
                    <div className="flex items-center mb-6 absolute bubble-border-block max-w-80 w-full lg:max-w-bubble lg:bubble-border-block">
                      <h4
                        id="shisan_q"
                        className="ui-heading ui-bubble-border bg-white
                    border-gray-500 border-3 h-full flex items-center justify-center py-2 px-6 rounded-full text-bluegray-700 text-center w-full">
                        資産運用、今のままで良いのかわからない
                      </h4>
                    </div>
                    <div className="flex justify-center items-center flex-col w-full px-8 pt-18 pb-4 lg:flex-row lg:justify-between lg:pt-14 lg:px-8">
                      <div className="mb-4 lg:mb-0 lg:w-320p">
                        <img
                          loading="lazy"
                          src="/static/images/lp/aruaru_ai.png"
                          alt=""
                          width="320"
                          height="160"
                          className=""
                        />
                      </div>
                      <div className="flex-1 text-base leading-7">
                        このままの運用方法で良いのかな・・
                        <br />
                        目標はあるけど達成できるのか自信がない。
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-center js-ui-animation-fadeup ui-animation-fadeup mb-4">
                  <i className="icon-chevron-down text-3xl text-bluegray-500"></i>
                </div>
                <h4 className="font-bold text-base text-center mb-8">
                  毎月のつみたて額と年数（年齢）から資産形成シミュレーション。
                  <br />
                  投資で目標金額を達成するまでをサポートします。
                </h4>

                <div className="mb-12 lg:flex lg:space-x-4">
                  <div className="mb-4 lg:w-1/2 lg:mb-0">
                    <h5 id="target_a" className="font-bold text-base">
                      毎月の目標金額や利回りをアドバイス
                    </h5>
                    <div className="text-base leading-7">
                      目標金額、毎月の積立額、年齢などから必要な利回りを自動で計算し、資産の増やし方をアドバイス。
                      <br />
                      グラフやポートフォリオ分析で、投資の実績と目標金額まであといくら増やせばいいのかがわかります。
                    </div>
                  </div>
                  <div className="ui-horizontal-scroll lg:flex justify-center lg:space-x-4 overflow-hidden">
                    <div className="ui-horizontal-scroll-item lg:w-1/2 h-56 lg:h-20 w-screen-60 overflow-hidden">
                      <img
                        loading="lazy"
                        src="/static/images/lp/ai_setting.png"
                        alt="資産目標サポート設定"
                        width="340"
                        height="626"
                        className=" js_toggle_switch image"
                        data-toggle="js_modal"
                        data-src="static/images/lp/ai_setting.png"
                      />
                    </div>
                    <div className="ui-horizontal-scroll-item lg:w-1/2 h-56 lg:h-20 w-screen-60 overflow-hidden">
                      <img
                        loading="lazy"
                        src="/static/images/lp/ai_piechart.png"
                        alt="資産目標サポート画面"
                        width="340"
                        height="626"
                        className=" js_toggle_switch image"
                        data-toggle="js_modal"
                        data-src="static/images/lp/ai_piechart.png"
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="flex justify-center items-center font-bold text-xl text-tradewell border border-tradewell rounded-lg max-w-btn-l mx-auto h-16 lg:text-2xl cursor-pointer"
                  id="click_login_start_target"
                  onClick={() =>
                    isMinkabuMember ? loginTarget() : registerTarget()
                  }>
                  資産の増やし方を見てみる
                  <div id="personachart" ref={reportPersonachart} />
                </div>
              </div>

              {/*ペルソナチャート*/}
              <div className="bg-white border rounded-lg shadow-panel py-12 px-6 mb-8 lg:px-6">
                <div className="flex flex-col items-center text-center border-b mb-8">
                  <h3 className="text-2xl text-sky-500 font-bold leading-9 mb-12">
                    『年収・投資先・年代』ごとに資産を比較！ペルソナチャート
                  </h3>
                  <div className="flex justify-center items-center justify-center flex-col border bg-gray-100 rounded-lg w-full max-w-776p mb-8 relative lg:flex-row">
                    <div className="flex items-center mb-6 absolute bubble-border-block max-w-80 w-full lg:max-w-bubble lg:bubble-border-block">
                      <h4
                        id="shisan_q"
                        className="ui-heading ui-bubble-border bg-white
                    border-gray-500 border-3 h-full flex items-center justify-center py-2 px-6 rounded-full text-bluegray-700 text-center w-full">
                        同じ年代の投資家ってどんな資産状況なの？
                      </h4>
                    </div>
                    <div className="flex justify-center items-center flex-col w-full px-8 pt-18 pb-4 lg:flex-row lg:justify-between lg:pt-14 lg:px-8">
                      <div className="mb-4 lg:mb-0 lg:w-320p">
                        <img
                          loading="lazy"
                          src="/static/images/lp/aruaru_persona-chart.png"
                          alt=""
                          width="320"
                          height="160"
                          className=""
                        />
                      </div>
                      <div className="flex-1 text-base leading-7">
                        他の人と比べて投資のパフォーマンスは良い？悪い？
                        <br />
                        利益を出している人はどんな投資をしているの？
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-center js-ui-animation-fadeup ui-animation-fadeup mb-4">
                  <i className="icon-chevron-down text-3xl text-bluegray-500"></i>
                </div>
                <h4 className="font-bold text-base text-center mb-8">
                  ペルソナチャートで他の投資家と自分の資産を比べてみよう
                </h4>

                <div className="mb-12 lg:flex lg:space-x-4">
                  <div className="mb-4 lg:w-1/2 lg:mb-0">
                    <h5 className="font-bold text-base">
                      現状を知ることで次のステップの参考に
                    </h5>
                    <div className="text-base leading-7">
                      年齢、投資先（株、NISAなど）、投資歴などの資産データを組み合わせたツールで自分と似た「ペルソナ」と比較できます。
                      <br />
                      利益を出している投資家の保有資産や資産変動を知ることで、資産形成のヒントが見つかります。
                    </div>
                  </div>
                  <div className="ui-horizontal-scroll lg:flex justify-center lg:space-x-4 overflow-hidden">
                    <div className="ui-horizontal-scroll-item lg:w-1/2 h-56 lg:h-20 w-screen-60 overflow-hidden">
                      <img
                        loading="lazy"
                        src="/static/images/lp/persona-chart1.png"
                        alt="ペルソナチャート画面"
                        width="340"
                        height="626"
                        className=" js_toggle_switch image"
                        data-toggle="js_modal"
                        data-src="static/images/lp/persona-chart1.png"
                      />
                    </div>
                    <div className="ui-horizontal-scroll-item lg:w-1/2 h-56 lg:h-20 w-screen-60 overflow-hidden ml-2">
                      <img
                        loading="lazy"
                        src="/static/images/lp/persona-chart2.png"
                        alt="ペルソナチャート画面"
                        width="340"
                        height="626"
                        className=" js_toggle_switch image"
                        data-toggle="js_modal"
                        data-src="static/images/lp/persona-chart2.png"
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="flex justify-center items-center font-bold text-xl text-tradewell border border-tradewell rounded-lg max-w-btn-l mx-auto h-16 lg:text-2xl cursor-pointer"
                  id="click_login_persona_chart"
                  onClick={() =>
                    isMinkabuMember
                      ? loginPersonaChart()
                      : registerPersonaChart()
                  }>
                  ペルソナチャートを使ってみる
                </div>
                <div id="dividend" />
              </div>

              {/*配当金*/}
              <div className="bg-white border rounded-lg shadow-panel py-12 px-6 mb-8 lg:px-6">
                <div className="flex flex-col items-center text-center border-b mb-8">
                  <h3 className="text-2xl text-sky-500 font-bold leading-9 mb-12">
                    配当金を自動で計算！配当予想も1年分わかる配当管理
                  </h3>
                  <div className="flex justify-center items-center justify-center flex-col border bg-gray-100 rounded-lg w-full max-w-776p mb-8 relative lg:flex-row">
                    <div className="flex items-center mb-6 absolute bubble-border-block max-w-80 w-full lg:max-w-bubble lg:bubble-border-block">
                      <h4
                        id="shisan_q"
                        className="ui-heading ui-bubble-border bg-white
                    border-gray-500 border-3 h-full flex items-center justify-center py-2 px-6 rounded-full text-bluegray-700 text-center w-full">
                        配当金いくら入金されるかな？
                      </h4>
                    </div>
                    <div className="flex justify-center items-center flex-col w-full px-8 pt-18 pb-4 lg:flex-row lg:justify-between lg:pt-14 lg:px-8">
                      <div className="mb-4 lg:mb-0 lg:w-320p">
                        <img
                          loading="lazy"
                          src="/static/images/lp/aruaru_dividend.png"
                          alt=""
                          width="320"
                          height="160"
                          className=""
                        />
                      </div>
                      <div className="flex-1 text-base leading-7">
                        配当金、毎月の計算が大変だな・・・
                        <br />
                        銘柄ごとに支払い月も年間配当も違うし
                        <br />
                        予想配当金も入金額もまとめて管理したいな
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-center js-ui-animation-fadeup ui-animation-fadeup mb-4">
                  <i className="icon-chevron-down text-3xl text-bluegray-500"></i>
                </div>
                <h4 className="font-bold text-xl text-center mb-6">
                  配当金の受取り額も<span className="text-xs">※</span>
                  、予想配当金もアプリで計算！入金支払い日も一覧でわかる
                </h4>

                <div className="mb-4 font-bold text-center">
                  月別に配当金の内訳をグラフで表示。銘柄ごとの配当金も一覧で見れます
                </div>
                <div className="mb-2 text-center">
                  アセプラでは複数の口座に入金される配当金をまとめて管理できます。
                  <br />
                  予想配当金は1年後まで月別に表示！過去の入金実績も自動で集計します。税引き表示も対応。
                </div>
                <div className="mb-8 text-xs text-center">
                  ※ 配当金の受取額の表示は、SBI証券、楽天証券のみとなります。
                </div>

                <div className="mb-12 lg:flex lg:space-x-8">
                  <div className="mb-4 lg:w-1/2 lg:mb-0">
                    <h5 className="font-bold text-lg">
                      年間配当金や入金実績もまとめて管理！NISA口座も対応
                    </h5>
                    <div className="text-base">
                      <div className="flex flex-row items-baseline lg:mt-4 mt-2">
                        <div className="icon-check_circle text-lg" />
                        <div className="ml-1">
                          過去の入金実績も銘柄ごとに自動で集計
                        </div>
                      </div>
                      <div className="flex flex-row items-baseline lg:mt-4 mt-2">
                        <div className="icon-check_circle text-lg" />
                        <div className="ml-1">
                          配当金の入金日を証券会社ごとに一覧で表示
                        </div>
                      </div>
                      <div className="flex flex-row items-baseline lg:mt-4 mt-2">
                        <div className="icon-check_circle text-lg" />
                        <div className="ml-1">
                          年間配当金、月別配当金がグラフで見れる
                        </div>
                      </div>
                      <div className="flex flex-row items-baseline lg:mt-4 mt-2">
                        <div className="icon-check_circle text-lg" />
                        <div className="ml-1">
                          予想配当金は、NISA口座など口座ごとに自動で計算
                        </div>
                      </div>
                      <div className="flex flex-row items-baseline lg:mt-4 mt-2">
                        <div className="icon-check_circle text-lg" />
                        <div className="ml-1">
                          配当金関連ニュースや配当情報も一覧でわかる
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ui-horizontal-scroll lg:flex justify-center overflow-hidden">
                    <div className="ui-horizontal-scroll-item lg:w-1/2 h-64 lg:h-20 lg:w-screen-60 overflow-hidden">
                      <img
                        loading="lazy"
                        src="/static/images/lp/dividend1.png"
                        alt="配当金画面"
                        width="191"
                        height="373"
                        className=" js_toggle_switch image"
                        data-toggle="js_modal"
                        data-src="static/images/lp/dividend1.png"
                      />
                    </div>
                    <div className="ui-horizontal-scroll-item lg:w-1/2 h-64 lg:h-20 lg:w-screen-60 overflow-hidden lg:ml-4">
                      <img
                        loading="lazy"
                        src="/static/images/lp/dividend2.png"
                        alt="配当金画面"
                        width="191"
                        height="373"
                        className=" js_toggle_switch image"
                        data-toggle="js_modal"
                        data-src="static/images/lp/dividend2.png"
                      />
                    </div>
                  </div>
                </div>
                <div className="p-4 mb-12 bg-teal-pale rounded-lg">
                  <div className="text-lg font-bold text-center">
                    配当金の入金シミュレーションが1年後までできる
                  </div>
                  <div className="mt-2 text-center">
                    アセプラでは1年後の予想配当金も支払い月ごと、保有商品（配当株、投信など）ごとに表示しています。
                    <br />
                    配当金の入金額をシミュレーションできるため、配当金を毎月分散して受け取りたい投資家にもおすすめです。
                  </div>
                </div>
                <div
                  className="flex justify-center items-center font-bold text-xl text-tradewell border border-tradewell rounded-lg max-w-btn-l mx-auto h-16 lg:text-2xl cursor-pointer"
                  id="click_login_persona_chart"
                  onClick={() =>
                    isMinkabuMember ? loginDividend() : registerDividend()
                  }>
                  配当管理を使ってみる
                </div>
              </div>
            </section>

            {/* 「資産がわからない」を卒業 */}
            <section className="text-white bg-slate-750">
              <div className="container flex flex-col items-center lg:px-0 px-1">
                <div className="flex items-end justify-center lg:mt-22 mt-16 mb-auto text-3xl leading-8">
                  <img src="/static/images/lp/line-white.svg" alt="" />
                  <div className="mx-4 lg:text-42 text-23 font-bold">
                    「資産がわからない」
                    <span className="lg:text-34 text-xl">を卒業</span>
                  </div>
                  <img
                    src="/static/images/lp/line-white.svg"
                    alt=""
                    style={{
                      transform: 'scale(-1, 1)',
                    }}
                  />
                </div>
                <div className="lg:mt-8 mt-6 lg:text-28 text-lg font-bold">
                  あなたの投資をサポート
                </div>

                {/* pc */}
                <div className="lg:flex hidden flex-col mt-4 text-36 font-bold text-center leading-12">
                  <div>
                    <span className="text-48">複数口座の投資</span>を
                  </div>
                  <div>まとめて管理！</div>
                </div>

                {/* sp */}
                <div className="lg:hidden flex flex-col mt-4 text-xl font-bold text-center leading-7">
                  <div className="">
                    <span className="text-34">複数口座の投資</span>を
                  </div>
                  <div className="">まとめて管理！</div>
                </div>

                <div className="h-4 lg:w-432p w-64 lg:mt-4 mt-2 bg-red-500 right-half mx-auto"></div>
                <div className="mt-8">
                  <img
                    src="/static/images/lp/recommend.svg"
                    alt="資産管理方法のおすすめ紹介"
                    className="w-full"
                  />
                </div>
              </div>
              {/* pc */}
              <div className="lg:flex hidden flex-col px-4 pb-16">
                <a href={linkSecuritiesAccountManagementLP()}>
                  <div
                    className="w-full flex justify-center items-center font-bold text-xl text-white border border-white rounded-lg max-w-btn-l mt-12 mx-auto h-16 cursor-pointer"
                    id="click_login_how_to_multiple_account_management_pc">
                    複数の証券口座の資産管理方法とは
                  </div>
                </a>
              </div>
              {/* sp */}
              <div className="lg:hidden flex flex-col px-4 pb-8">
                <a href={linkSecuritiesAccountManagementLP()}>
                  <div
                    className="flex justify-center items-center font-bold text-xl text-white border border-white rounded-lg py-2 max-w-btn-l mt-12 mx-auto cursor-pointer"
                    id="click_login_how_to_multiple_account_management_sp">
                    複数の証券口座の
                    <br />
                    資産管理方法とは
                  </div>
                </a>
              </div>
            </section>

            {/* 今の運用のままで大丈夫？ */}
            <section className="lg:mb-16 pt-8 lg:px-4 bg-white">
              <div className="flex flex-col items-center">
                <div className="flex items-end justify-center lg:mt-16 mt-8 mb-auto text-3xl leading-8">
                  <img src="/static/images/lp/line.svg" alt="" />
                  <div className="mx-4 lg:text-42 text-23 font-bold text-sky-500">
                    今の運用のままで大丈夫？
                  </div>
                  <img
                    src="/static/images/lp/line.svg"
                    alt=""
                    style={{
                      transform: 'scale(-1, 1)',
                    }}
                  />
                </div>
                <h2 className="text-center mt-4">
                  <span className="mt-8 lg:text-28 text-lg font-bold">
                    あなたのポートフォリオを分析
                  </span>
                  <br />
                  <span className="mb-2 lg:text-4xl text-lg font-bold">
                    <span className="lg:text-48 text-28">AIのアドバイス</span>で
                    <span className="lg:text-48 text-28">投資</span>の<br />
                    目標を達成しよう！
                  </span>
                </h2>

                <div className="h-4 lg:w-432p w-64 bg-red-500 right-half mx-auto"></div>
                <div className="lg:flex hidden">
                  <img
                    src="/static/images/lp/ai_advice_pc.png"
                    alt=""
                    className="mt-8 mx-auto"
                  />
                </div>
                <div className="flex lg:hidden">
                  <img
                    src="/static/images/lp/ai_advice_sp.png"
                    alt=""
                    className="mt-8 mx-auto"
                    style={{ width: '314px', height: '252px' }}
                  />
                </div>
                <div className="w-full flex justify-center lg:mt-16 mt-8 mb-16 px-4">
                  <a
                    href="https://tw.minkabu.jp/targetLP"
                    className="flex justify-center items-center ui-button theme-normal max-w-624p w-full h-20"
                    id="click_login_how_to_ai_portfolio">
                    <div className="flex flex-col font-bold">
                      <div className="flex items-end justify-between lg:mb-auto app-primary-label-block">
                        リスクに備えた投資ができる
                      </div>
                      <div className="lg:mt-1 text-xl">
                        AIポートフォリオ分析とは
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </section>

            <section className="container px-2 mb-16 pt-16 js-ui-animation-fadeup lg:px-4">
              {/*アセプラ利用者の声*/}
              <div className="text-center mb-8">
                <h2 id="product" className="lg:text-3xl text-xl font-bold mb-2">
                  アセプラ利用者の声
                </h2>
                <div className="h-4 w-64 bg-red-500 right-half mx-auto"></div>
              </div>
              {/* PC */}
              <div className="hidden lg:flex flex-col">
                <div
                  className="grid"
                  style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                  <div className="mx-4 py-6 px-5 bg-white border rounded-lg shadow-panel text-base">
                    <div>
                      <img
                        src="/static/images/lp/person1.png"
                        alt="人物1"
                        width="100"
                        height="100"
                        className="mx-auto"
                      />
                    </div>
                    <div className="font-bold text-sky-500 mt-4 text-center">
                      20代 男性
                    </div>
                    <div className="font-bold mt-4 text-center">
                      LINEに最新の資産が毎日届く
                    </div>
                    <div className="mt-4">
                      毎日夕方になると、保有銘柄の前日比の損益や資産総額をまとめたレポートが届きました。毎日届くので細かな資産変動があったときにもすぐに対応できて大変助かりました。
                    </div>
                  </div>
                  <div className="mx-4 py-6 px-5 bg-white border rounded-lg shadow-panel text-base">
                    <div>
                      <img
                        src="/static/images/lp/person2.png"
                        alt="人物2"
                        width="100"
                        height="100"
                        className="mx-auto"
                      />
                    </div>
                    <div className="font-bold text-red-500 mt-4 text-center">
                      30代 女性
                    </div>
                    <div className="font-bold mt-4 text-center">
                      家族の資産も銀行口座もまとめられる
                    </div>
                    <div className="mt-4">
                      銀行口座が複数あるため、1つにまとめて計算することができてよかった。夫の口座や投資信託の口座も合算でき、家計がわかりやすくなった。
                    </div>
                  </div>
                  <div className="mx-4 py-6 px-5 bg-white border rounded-lg shadow-panel text-base">
                    <div>
                      <img
                        src="/static/images/lp/person3.png"
                        alt="人物3"
                        width="100"
                        height="100"
                        className="mx-auto"
                      />
                    </div>
                    <div className="font-bold text-sky-500 mt-4 text-center">
                      30代 男性
                    </div>
                    <div className="font-bold mt-4 text-center">
                      通知機能が使える！
                    </div>
                    <div className="mt-4">
                      保有する銘柄が情報を開示したら通知が来て、常に最新情報をチェックできる。銘柄の情報を調べる手間が省ける上に、大事な発表を見落としてせっかくのチャンスを逃すこともなくなった。
                    </div>
                  </div>
                </div>
                <div
                  className="grid mt-8"
                  style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                  <div className="mx-4 py-6 px-5 bg-white border rounded-lg shadow-panel text-base">
                    <div>
                      <img
                        src="/static/images/lp/person4.png"
                        alt="人物4"
                        width="100"
                        height="100"
                        className="mx-auto"
                      />
                    </div>
                    <div className="font-bold text-red-500 mt-4 text-center">
                      30代 女性
                    </div>
                    <div className="font-bold mt-4 text-center">
                      頼りになるAIアドバイザー
                    </div>
                    <div className="mt-4">
                      投資初心者なので、どのように資産運用をすればいいか不安だったが、目標金額などを設定したら利回りの計算や運用に対するアドバイスがもらえたので助かった！
                    </div>
                  </div>
                  <div className="mx-4 py-6 px-5 bg-white border rounded-lg shadow-panel text-base">
                    <div>
                      <img
                        src="/static/images/lp/person5.png"
                        alt="人物5"
                        width="100"
                        height="100"
                        className="mx-auto"
                      />
                    </div>
                    <div className="font-bold text-sky-500 mt-4 text-center">
                      40代 男性
                    </div>
                    <div className="font-bold mt-4 text-center">
                      すべての資産の動きが見えて便利
                    </div>
                    <div className="mt-4">
                      複数の口座をもっていると、どの口座が増えたのか、減ったのかがいまいちよくわからないが、このサービスはさまざまな口座をまとめて管理しているので、各口座にログインする手間が省けた。
                    </div>
                  </div>
                  <div className="mx-4 py-6 px-5 bg-white border rounded-lg shadow-panel text-base">
                    <div>
                      <img
                        src="/static/images/lp/person6.png"
                        alt="人物6"
                        width="100"
                        height="100"
                        className="mx-auto"
                      />
                    </div>
                    <div className="font-bold text-sky-500 mt-4 text-center">
                      40代 男性
                    </div>
                    <div className="font-bold mt-4 text-center">
                      株式の取引履歴も確認できて満足
                    </div>
                    <div className="mt-4">
                      よくある資産管理アプリは証券口座の金額だけ表示されるものが多いが、このサービスは所有している株式や投資信託の取引履歴も保存できる。
                      <br />
                      資産の増減だけでなく、投資の振り返りもできるため良かった。
                    </div>
                  </div>
                </div>
              </div>
              {/* SP */}
              <div className="flex lg:hidden">
                <div className="ui-horizontal-scroll justify-center overflow-hidden">
                  <div className="ui-horizontal-scroll-item w-4/5 overflow-hidden">
                    <div className="py-6 px-5 bg-white border rounded-lg shadow-panel min-h-104 text-base">
                      <div>
                        <img
                          src="/static/images/lp/person1.png"
                          alt="人物1"
                          width="100"
                          height="100"
                          className="mx-auto"
                        />
                      </div>
                      <div className="font-bold text-sky-500 mt-4 text-center">
                        20代 男性
                      </div>
                      <div className="font-bold mt-4 text-center">
                        LINEに最新の資産が毎日届く
                      </div>
                      <div className="mt-4">
                        毎日夕方になると、保有銘柄の前日比の損益や資産総額をまとめたレポートが届きました。毎日届くので細かな資産変動があったときにもすぐに対応できて大変助かりました。
                      </div>
                    </div>
                  </div>
                  <div className="ui-horizontal-scroll-item w-4/5 overflow-hidden ml-4">
                    <div className="py-6 px-5 bg-white border rounded-lg shadow-panel min-h-104 text-base">
                      <div>
                        <img
                          src="/static/images/lp/person2.png"
                          alt="人物2"
                          width="100"
                          height="100"
                          className="mx-auto"
                        />
                      </div>
                      <div className="font-bold text-red-500 mt-4 text-center">
                        30代 女性
                      </div>
                      <div className="font-bold mt-4 text-center">
                        家族の資産も銀行口座もまとめられる
                      </div>
                      <div className="mt-4">
                        銀行口座が複数あるため、1つにまとめて計算することができてよかった。夫の口座や投資信託の口座も合算でき、家計がわかりやすくなった。
                      </div>
                    </div>
                  </div>
                  <div className="ui-horizontal-scroll-item w-4/5 overflow-hidden ml-4">
                    <div className="py-6 px-5 bg-white border rounded-lg shadow-panel min-h-104 text-base">
                      <div>
                        <img
                          src="/static/images/lp/person3.png"
                          alt="人物3"
                          width="100"
                          height="100"
                          className="mx-auto"
                        />
                      </div>
                      <div className="font-bold text-sky-500 mt-4 text-center">
                        30代 男性
                      </div>
                      <div className="font-bold mt-4 text-center">
                        通知機能が使える！
                      </div>
                      <div className="mt-4">
                        保有する銘柄が情報を開示したら通知が来て、常に最新情報をチェックできる。銘柄の情報を調べる手間が省ける上に、大事な発表を見落としてせっかくのチャンスを逃すこともなくなった。
                      </div>
                    </div>
                  </div>
                  <div className="ui-horizontal-scroll-item w-4/5 overflow-hidden ml-4">
                    <div className="py-6 px-5 bg-white border rounded-lg shadow-panel min-h-104 text-base">
                      <div>
                        <img
                          src="/static/images/lp/person4.png"
                          alt="人物4"
                          width="100"
                          height="100"
                          className="mx-auto"
                        />
                      </div>
                      <div className="font-bold text-red-500 mt-4 text-center">
                        30代 女性
                      </div>
                      <div className="font-bold mt-4 text-center">
                        頼りになるAIアドバイザー
                      </div>
                      <div className="mt-4">
                        投資初心者なので、どのように資産運用をすればいいか不安だったが、目標金額などを設定したら利回りの計算や運用に対するアドバイスがもらえたので助かった！
                      </div>
                    </div>
                  </div>
                  <div className="ui-horizontal-scroll-item w-4/5 overflow-hidden ml-4">
                    <div className="py-6 px-5 bg-white border rounded-lg shadow-panel min-h-104 text-base">
                      <div>
                        <img
                          src="/static/images/lp/person5.png"
                          alt="人物5"
                          width="100"
                          height="100"
                          className="mx-auto"
                        />
                      </div>
                      <div className="font-bold text-sky-500 mt-4 text-center">
                        40代 男性
                      </div>
                      <div className="font-bold mt-4 text-center">
                        すべての資産の動きが見えて便利
                      </div>
                      <div className="mt-4">
                        複数の口座をもっていると、どの口座が増えたのか、減ったのかがいまいちよくわからないが、このサービスはさまざまな口座をまとめて管理しているので、各口座にログインする手間が省けた。
                      </div>
                    </div>
                  </div>
                  <div className="ui-horizontal-scroll-item w-4/5 overflow-hidden ml-4">
                    <div className="py-6 px-5 bg-white border rounded-lg shadow-panel min-h-104 text-base">
                      <div>
                        <img
                          src="/static/images/lp/person6.png"
                          alt="人物6"
                          width="100"
                          height="100"
                          className="mx-auto"
                        />
                      </div>
                      <div className="font-bold text-sky-500 mt-4 text-center">
                        40代 男性
                      </div>
                      <div className="font-bold mt-4 text-center">
                        株式の取引履歴も確認できて満足
                      </div>
                      <div className="mt-4">
                        よくある資産管理アプリは証券口座の金額だけ表示されるものが多いが、このサービスは所有している株式や投資信託の取引履歴も保存できる。
                        <br />
                        資産の増減だけでなく、投資の振り返りもできるため良かった。
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="accountinfo" ref={accountInfoScroll}></div>
            </section>

            {/*データ連携可能な口座*/}
            <section className="bg-white pt-16 pb-16 js-ui-animation-fadeup lg:px-8 px-4">
              <div className="text-center mb-12">
                <h2
                  id="data"
                  className="text-xl font-bold mb-2 lg:text-3xl lg:mb-4">
                  データ連携可能な口座
                </h2>
                <div className="h-4 w-64 bg-red-500 right-half mx-auto"></div>
              </div>
              {/*口座連携可能な証券会社*/}
              <div className="container">
                <div className="mb-16 text-center">
                  <h3 id="data_com" className="text-lg font-bold mb-2">
                    口座連携可能な証券会社
                  </h3>
                  <p className="text-bluegray-500 text-sm">
                    連携が可能な証券会社と金融商品は今後追加していく予定です。
                  </p>
                </div>
                <div className="flex flex-row justify-center">
                  <div className="px-1">
                    <div className="px-6 bg-tradewell text-white rounded-full">
                      無料
                    </div>
                  </div>
                  <div className="px-1 text-lg font-bold text-red-500">
                    SBI証券
                  </div>
                </div>
                {/* PC */}
                <div className="lg:flex hidden flex-col">
                  <div className="flex flex-row items-cener justify-center pt-4 text-lg font-bold">
                    <div className="text-center mx-8">楽天証券</div>
                    <div className="text-center mx-8">松井証券</div>
                    <div className="text-center mx-8">マネックス証券</div>
                    <div className="text-center mx-8">
                      三菱UFJ eスマート証券
                      <span className="text-sm font-normal">※1</span>
                    </div>
                  </div>
                  <div className="flex flex-row items-cener justify-center pt-4 text-lg font-bold">
                    <div className="text-center mx-8">野村證券</div>
                    <div className="text-center mx-8">SMBC日興証券</div>
                    <div className="text-center mx-8">みずほ証券</div>
                    <div className="text-center mx-8">大和証券</div>
                  </div>
                  <div className="flex flex-row items-cener justify-center pt-4 text-lg font-bold">
                    <div className="text-center mx-8">
                      岡三証券
                      <span className="text-sm font-normal">※2</span>
                    </div>
                    <div className="text-center mx-8">
                      三菱UFJモルガン・スタンレー証券
                    </div>
                  </div>
                </div>
                {/* SP */}
                <div className="lg:hidden flex text-base font-bold text-center">
                  <div>
                    <div className="inline-block pt-4 px-4">楽天証券</div>
                    <div className="inline-block pt-4 px-4">松井証券</div>
                    <div className="inline-block pt-4 px-4">マネックス証券</div>
                    <div className="inline-block pt-4 px-4">
                      三菱UFJ eスマート証券
                      <span className="text-sm font-normal">※1</span>
                    </div>
                    <div className="inline-block pt-4 px-4">野村證券</div>
                    <div className="inline-block pt-4 px-4">SMBC日興証券</div>
                    <div className="inline-block pt-4 px-4">みずほ証券</div>
                    <div className="inline-block pt-4 px-4">大和証券</div>
                    <div className="inline-block pt-4 px-4">
                      岡三証券
                      <span className="text-sm font-normal">※2</span>
                    </div>
                    <div className="inline-block pt-4 px-4">
                      三菱UFJモルガン・スタンレー証券
                    </div>
                  </div>
                </div>
                <div className="pt-4 text-center text-sm">
                  ※1 旧auカブコム証券
                </div>
                <div className="text-center text-sm">
                  ※2 旧岡三オンライン証券を除く
                </div>
                {/*スクロールさせる*/}
                {/* PC */}
                <div className="hidden lg:flex mt-8 justify-center">
                  <table className="w-full table-fixed">
                    <thead>
                      <tr className="bg-bluegray-50 h-16">
                        <th className="border-b border-gray-300 font-normal text-base">
                          連携可能な金融商品
                        </th>
                        <th className="border-b border-gray-300 font-normal">
                          <div className="text-sm">国内株式</div>
                          <div className="text-sm">(現物/信用)</div>
                        </th>
                        <th className="border-b border-gray-300 font-normal">
                          <div className="text-sm">米国株式</div>
                          <div className="text-sm">(現物のみ)</div>
                        </th>
                        <th className="border-b border-gray-300 font-normal">
                          <div className="text-sm">外国株式</div>
                          <div className="text-sm">(現物のみ)</div>
                        </th>
                        <th className="border-b border-gray-300 font-normal text-base">
                          投資信託
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="h-16">
                        <td className="border-b border-gray-300 text-center">
                          各証券会社
                        </td>
                        <td className="border-b border-gray-300 text-center">
                          <p className="text-2xl font-bold text-red-500">○</p>
                        </td>
                        <td className="border-b border-gray-300 text-center">
                          <p className="text-2xl font-bold text-red-500">○</p>
                        </td>
                        <td className="border-b border-gray-300 text-center">
                          <p className="text-2xl font-bold text-red-500">○</p>
                        </td>
                        <td className="border-b border-gray-300 text-center">
                          <p className="text-2xl font-bold text-red-500">○</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {/* SP */}
                <div className="flex lg:hidden mt-8 justify-center">
                  <table className="w-full table-fixed">
                    <thead>
                      <tr className="h-16">
                        <th className="bg-bluegray-50 border-b border-gray-300 font-normal text-base">
                          連携可能な金融商品
                        </th>
                        <th className="border-b border-gray-300 font-normal">
                          <div className="text-base">各証券会社</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="h-16">
                        <td className="bg-bluegray-50 border-b border-gray-300 text-center">
                          <div className="text-sm">国内株式</div>
                          <div className="text-sm">(現物/信用)</div>
                        </td>
                        <td className="border-b border-gray-300 text-center">
                          <p className="text-2xl font-bold text-red-500">○</p>
                        </td>
                      </tr>
                      <tr className="h-16">
                        <td className="bg-bluegray-50 border-b border-gray-300 text-center">
                          <div className="text-sm">米国株式</div>
                          <div className="text-sm">(現物のみ)</div>
                        </td>
                        <td className="border-b border-gray-300 text-center text-sm">
                          <p className="text-2xl font-bold text-red-500">○</p>
                        </td>
                      </tr>
                      <tr className="h-16">
                        <td className="bg-bluegray-50 border-b border-gray-300 text-center">
                          <div className="text-sm">外国株式</div>
                          <div className="text-sm">(現物のみ)</div>
                        </td>
                        <td className="border-b border-gray-300 text-center text-sm">
                          <p className="text-2xl font-bold text-red-500">○</p>
                        </td>
                      </tr>
                      <tr className="h-16">
                        <td className="bg-bluegray-50 border-b border-gray-300 text-center text-base">
                          投資信託
                        </td>
                        <td className="border-b border-gray-300 text-center">
                          <p className="text-2xl font-bold text-red-500">○</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {/* 外出し */}
                <div className="border-b border-gray-300 pb-8">
                  <div className="mt-4 text-center leading-5 text-sm">
                    <div>
                      特定口座/NISA口座/一般口座
                      <span className="text-1.5xs text-bluegray-500">※</span>
                      　に対応しています。
                    </div>
                    <div className="text-bluegray-500">
                      ※一般口座では保有株式については反映されますが損益は不明なため反映されません
                    </div>
                    <div className="text-bluegray-500">
                      ※現在、マネックス証券と総合証券は取引履歴は表示されません
                    </div>
                  </div>
                </div>
                <div className="mb-8 text-center border-b border-gray-300 py-8">
                  <h3
                    id="data_moneytree"
                    className="text-lg font-bold lg:text-center mb-4">
                    確定拠出年金口座
                  </h3>
                  <div className="lg:flex hidden flex-col mx-40 text-lg font-bold">
                    <div className="flex flex-row justify-between pt-4">
                      <div className="pr-6">SBI ベネフィット・システムズ</div>
                      <div className="">
                        日本レコード・キーピング・ネットワーク（NRK）
                      </div>
                    </div>
                    <div className="pt-4 pr-3 text-left">
                      日本インベスター・ソリューション・アンド・テクノロジー（JIS&T）
                    </div>
                  </div>
                  <div className="lg:hidden flex text-base font-bold text-center">
                    <div>
                      <div className="inline-block pt-4">
                        SBI ベネフィット・システムズ
                      </div>
                      <div className="inline-block pt-4">
                        日本レコード・キーピング・ネットワーク（NRK）
                      </div>
                      <div className="inline-block pt-4">
                        日本インベスター・ソリューション・アンド・テクノロジー（JIS&T）
                      </div>
                    </div>
                  </div>
                </div>
                {/*口座残高データを連携可能な証券会社*/}
                <div className="mb-8 text-center border-b border-gray-300 py-8">
                  <h3
                    id="data_moneytree"
                    className="text-lg font-bold lg:text-center mb-4">
                    上記以外の金融機関はMoneytreeで連携可能です
                    <br />
                    <span className="text-sm">(マネーツリー対応口座)</span>
                  </h3>
                  <ul className="text-sm">
                    <li className="inline-block mb-2 px-0.5">
                      GMOクリック証券 /
                    </li>
                    <li className="inline-block mb-2 px-0.5">
                      SBI ベネフィット・システムズ確定拠出年金 /
                    </li>
                    <li className="inline-block mb-2 px-0.5">
                      SBIネオトレード証券 /
                    </li>
                    <li className="inline-block mb-2 px-0.5">
                      SBIネオモバイル証券 /
                    </li>
                    <li className="inline-block  px-3 mb-2">SBI証券 /</li>
                    <li className="inline-block mb-2 px-0.5">SMBC日興証券 /</li>
                    <li className="inline-block px-3  mb-2">THEO /</li>
                    <li className="inline-block mb-2 px-0.5">WealthNavi /</li>
                    <li className="inline-block px-3 b-2">オリックス生命 /</li>
                    <li className="inline-block mb-2 px-0.5">セゾン投信 /</li>
                    <li className="inline-block mb-2 px-0.5">
                      マネックス証券 /
                    </li>
                    <li className="inline-block mb-2 px-0.5">みずほ証券 /</li>
                    <li className="inline-block mb-2 px-0.5">ネット倶楽部 /</li>
                    <li className="inline-block mb-2 px-0.5">
                      よこしん投信（横浜信用金庫） /
                    </li>
                    <li className="inline-block mb-2 px-0.5">
                      岡三オンライン証券 /
                    </li>
                    <li className="inline-block mb-2 px-0.5">楽天証券 /</li>
                    <li className="inline-block mb-2 px-0.5">
                      三菱ＵＦＪモルガン・スタンレー証券 /
                    </li>
                    <li className="inline-block mb-2 px-0.5">
                      三菱UFJ eスマート証券（旧auカブコム証券） /
                    </li>
                    <li className="inline-block mb-2 px-0.5">松井証券 /</li>
                    <li className="inline-block mb-2 px-0.5">荘銀投信 /</li>
                    <li className="inline-block mb-2 px-0.5">ダイレクト /</li>
                    <li className="inline-block mb-2 px-0.5">
                      損保ジャパンＤＣ証券確定拠出年金 /
                    </li>
                    <li className="inline-block mb-2 px-0.5">大和証券 /</li>
                    <li className="inline-block mb-2 px-0.5">
                      日本インベスター・ソリューション・アンド・テクノロジー確定拠出年金（JIS&T）
                      /
                    </li>
                    <li className="inline-block mb-2 px-0.5">
                      日本レコード・キーピング・ネットワーク確定拠出年金 /
                    </li>
                    <li className="inline-block mb-2 px-0.5">
                      北都投信ダイレクト /
                    </li>
                    <li className="inline-block mb-2 px-0.5">野村證券</li>
                  </ul>
                  <p className="text-sm mb-2">
                    その他、銀行口座残高・電子マネーなどの資産も連携しております。
                  </p>
                </div>
                {/*推奨環境*/}
                <div className=" ">
                  <h3 id="env" className="text-lg font-bold mb-2 text-center">
                    推奨環境
                  </h3>
                  <p className="mb-4 lg:text-center">
                    本サービスはスマートフォン向けサービスです。
                    <br />
                    以下の環境以外では正常に動作しない可能性がございます。
                  </p>
                  <div className="flex justify-center space-x-4">
                    <div className="text-left">
                      <div className="font-bold text-lg">iOS</div>
                      <ul className="pl-4 list-disc">
                        <li>Safari 最新版</li>
                        <li>Chrome 最新版</li>
                      </ul>
                    </div>
                    <div className="text-left">
                      <div className="font-bold text-lg">Android</div>
                      <ul className="pl-4 list-disc">
                        <li>Chrome 最新版</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/*アセプラの利用料金*/}
            <section className="container px-2 mb-16 pt-16 js-ui-animation-fadeup">
              <div className="text-center mb-12">
                <h2
                  id="price"
                  className="text-xl font-bold mb-2 lg:text-3xl lg:mb-4">
                  アセプラの利用料金
                </h2>
                <div className="h-4 w-64 bg-red-500 right-half mx-auto"></div>
              </div>

              {/*会員プランとご利用いただける機能*/}
              <div className="ui-card p-4 lg:mx-4">
                <div className="text-center">
                  <h3 id="value" className="mt-4 text-2xl font-bold">
                    会員プランとご利用いただける機能
                  </h3>
                </div>
                <table className="text-center w-full table-fixed">
                  <thead>
                    <tr className="border-b border-gray-400 py-4">
                      <td></td>
                      <td className="px-2 py-4 align-bottom">
                        <div className="font-bold">プレミアム会員</div>
                        <span className="text-xs">月額1,320円（税込）</span>
                        {!isApp && (
                          <a
                            href="https://id.minkabu.jp/premium_lp.html"
                            className="ui-button theme-normal mt-2 lg:w-32 mx-auto">
                            登録
                          </a>
                        )}
                      </td>
                      <td className="px-2 py-4 align-bottom">
                        <div className="font-bold">みんかぶ会員</div>
                        <span className="text-xs">無料</span>
                        {!isApp && (
                          /* eslint-disable jsx-a11y/anchor-is-valid */
                          <a
                            href="#"
                            className="ui-button theme-sub mt-2 md:w-32 mx-auto"
                            onClick={event => {
                              event.preventDefault();
                              event.stopPropagation();
                              register();
                            }}>
                            登録
                          </a>
                          /* eslint-enable jsx-a11y/anchor-is-valid */
                        )}
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-gray-400 py-4">
                      <td className="px-2 py-4">
                        <p className="text-red font-bold">
                          <span className="text-xs rounded-full bg-gray-700 text-white py-1 px-2">
                            アセプラ
                          </span>
                          <br />
                          <span className="text-lg">口座一括管理機能</span>
                        </p>
                        <p className="text-xs">資産が一目でわかる</p>
                      </td>
                      <td className="px-2 py-4 bg-orange-pale">
                        <p className="text-3xl font-bold text-red">◎</p>
                        <span className="text-xs">
                          複数口座登録可
                          <br />
                          連携可能口座※
                        </span>
                      </td>
                      <td className="px-2 py-4">
                        <p className=" text-2xl font-bold text-orange">○</p>
                        <span className="text-xs">SBI証券のみ</span>
                      </td>
                    </tr>
                    <tr className="border-b border-gray-400 py-4">
                      <td className="px-2 py-4">
                        <p className="text-red font-bold">
                          <span className="text-xs rounded-full bg-gray-700 text-white py-1 px-2">
                            アセプラ
                          </span>
                          <br />
                          <span className="text-lg">資産情報レポート</span>
                        </p>
                        <p className="text-xs">気づきから改善へつなげる</p>
                      </td>
                      <td className="px-2 py-4 bg-orange-pale">
                        <p className="text-3xl font-bold text-red">◎</p>
                      </td>
                      <td className="px-2 py-4">
                        <p className="text-2xl font-bold text-orange">○</p>
                        <span className="text-xs">特定の通知のみ</span>
                      </td>
                    </tr>
                    <tr className="border-b border-gray-400 py-4">
                      <td className="px-2 py-4">
                        <p className="text-red font-bold">
                          <span className="text-xs rounded-full bg-gray-700 text-white py-1 px-2">
                            アセプラ
                          </span>
                          <br />
                          <span className="text-lg">資産目標サポート</span>
                        </p>
                        <p className="text-xs">資産目標に向けた提案</p>
                      </td>
                      <td className="px-2 py-4 bg-orange-pale">
                        <p className="text-3xl font-bold text-red">◎</p>
                      </td>
                      <td className="px-2 py-4">
                        <p className="text-2xl font-bold text-gray">-</p>
                      </td>
                    </tr>
                    <tr className="border-b border-gray-400 py-4">
                      <td className="px-2 py-4">
                        <p className="text-red font-bold">
                          <span className="text-xs rounded-full bg-gray-700 text-white py-1 px-2">
                            アセプラ
                          </span>
                          <br />
                          <span className="text-lg">ペルソナチャート</span>
                        </p>
                        <p className="text-xs">他の会員や目標との比較</p>
                      </td>
                      <td className="px-2 py-4 bg-orange-pale">
                        <p className="text-3xl font-bold text-red">◎</p>
                      </td>
                      <td className="px-2 py-4">
                        <p className="text-2xl font-bold text-gray">-</p>
                      </td>
                    </tr>
                    <tr className="border-b border-gray-400 py-4">
                      <td className="px-2 py-4">
                        <p className="text-red font-bold">
                          <span className="text-xs rounded-full bg-gray-700 text-white py-1 px-2">
                            マガジン
                          </span>
                          <br />
                          <span className="text-lg">資産形成トレンド情報</span>
                        </p>
                        <p className="text-xs">お金のことを楽しく学ぶ</p>
                      </td>
                      <td className="px-2 py-4 bg-orange-pale">
                        <p className="text-3xl font-bold text-red">◎</p>
                      </td>
                      <td className="px-2 py-4">
                        <p className="text-2xl font-bold text-yellow">△</p>
                        <span className="text-xs">一部閲覧可</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p className="text-sm mt-2 mb-16">
                  ※SBI証券／楽天証券／松井証券／三菱UFJ
                  eスマート証券／マネックス証券／野村證券／みずほ証券／大和証券／SMBC日興証券／岡三証券／三菱UFJモルガン・スタンレー証券の口座が連携可能です
                  （2023年9月時点）
                </p>
                <div className="lg:px-4">
                  <div className="flex flex-col items-center bg-gray-100 border rounded-lg text-center px-4 pt-6 pb-8 lg:px-16">
                    <div className="text-lg font-bold leading-7 mb-2">
                      みんかぶプレミアムに登録して
                      <br />
                      アセプラを便利に使いこなそう！
                    </div>
                    <div className="text-base leading-6 mb-6">
                      みんかぶプレミアムに登録すると、アセットプランナーの全ての機能が使えるのはもちろん
                      <br />
                      好きな条件で銘柄が探せる機能や投資に役立つコラムなど、メディア「みんかぶ」の有料会員向けサービスも
                      <br />
                      ご利用いただけます。
                    </div>
                    {isApp ? (
                      <div
                        className="flex justify-center items-center ui-button theme-normal max-w-464p w-full h-16 cursor-pointer"
                        id="click_login_how_to_premium_1"
                        onClick={handlePremiumLp}>
                        みんかぶプレミアムとは？
                      </div>
                    ) : (
                      <a
                        href="https://id.minkabu.jp/premium_lp.html"
                        className="flex justify-center items-center ui-button theme-normal max-w-464p w-full h-16"
                        id="click_login_how_to_premium_2">
                        みんかぶプレミアムとは？
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </section>
            {/*セキュリティについて*/}
            <section className="bg-white pt-16 pb-16 js-ui-animation-fadeup">
              <div className="container px-2">
                <div className="text-center mb-8">
                  <h2 id="security" className="lg:text-3xl text-xl font-bold">
                    セキュリティについて
                  </h2>
                  <div className="h-4 w-64 bg-red-500 right-half mx-auto mt-2"></div>
                </div>

                <div className="p-4 lg:flex items-center ">
                  <div className="lg:w-1/4 text-center">
                    <img
                      loading="lazy"
                      src="/static/images/lp/privacy.png"
                      alt="個人情報保護への取組み"
                      width="200"
                      height="100"
                      className="mx-auto"
                    />
                  </div>
                  <div className="lg:w-3/4">
                    <h3
                      id="security_info"
                      className="font-bold text-blue text-2xl mb-4">
                      個人情報保護への取組み
                    </h3>
                    <p className="mb-8 leading-relax">
                      株式会社ミンカブ・ジ・インフォノイドは、事業を展開していくうえで、個人情報の保護が重大なテーマであると認識し、
                      個人情報を適切に管理することを社会的責務であると考えております。
                      個人情報保護に関する基本方針を以下のとおり定め、役員、従業員および関係者に周知徹底を図り、個人情報の保護に努めてまいります。
                      <br />
                      <a
                        href="https://minkabu.co.jp/privacy_policy"
                        target="_blank"
                        rel="noopener"
                        className="text-link mt-2">
                        プライバシーポリシー
                        <i className="icon-external-link ml-2"></i>
                      </a>
                    </p>
                  </div>
                </div>

                <div className="p-4 lg:flex items-center ">
                  <div className="lg:w-1/4 text-center">
                    <img
                      loading="lazy"
                      src="/static/images/lp/password.png"
                      alt="パスワード不要"
                      width="200"
                      height="100"
                      className="mx-auto"
                    />
                  </div>
                  <div className="lg:w-3/4">
                    <h3
                      id="security_password"
                      className="font-bold text-blue text-2xl mb-4">
                      パスワード情報について
                    </h3>
                    <p className="mb-8 leading-relax">
                      証券口座の連携のためにみんかぶアセットプランナー上でご入力いただく情報は証券会社の「ログインID」と「パスワード」です。
                      <br />
                      証券取引に関わるパスワードをお聞きすることはありません。
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section className="container px-2 mb-16 pt-16 js-ui-animation-fadeup lg:px-4">
              {/*メディア情報*/}
              <div className="text-center mb-8">
                <h2 id="product" className="lg:text-3xl text-xl font-bold mb-2">
                  メディア情報
                </h2>
                <div className="h-4 w-64 bg-red-500 right-half mx-auto"></div>
              </div>
              {/* PC */}
              <div className="bg-white border rounded-lg shadow-panel py-10 px-24 lg:flex lg:flex-row hidden">
                <div className="w-1/2">
                  <div className="login-app flex items-center justify-center login-app-banner">
                    <div className="flex justify-center w-full">
                      <div className="flex flex-col justify-end max-w-375p">
                        <div className="flex items-end justify-between mb-auto app-primary-label-block">
                          <div className="inline-flex items-center flex-col text-bluegray-700 font-bold">
                            フォローはこちらから
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-row justify-center mt-4">
                    <a
                      href="https://twitter.com/minkabu_asepla"
                      target="_blank"
                      rel="noopener">
                      <img
                        src="/static/images/lp/x_icon.svg"
                        alt="twitter"
                        width="75"
                        height="75"
                      />
                    </a>
                  </div>
                </div>
                <div className="w-1/2 text-base">
                  <div className="text-xl font-bold">
                    アセプラ公式 X アカウント
                  </div>
                  <div className="mt-1">
                    アセプラの活用方法やリリース情報をお知らせします。
                  </div>
                  <div className="mt-1 text-link">
                    <a
                      href="https://twitter.com/minkabu_asepla"
                      target="_blank"
                      rel="noopener">
                      @minkabu_asepla
                    </a>
                  </div>
                  <div className="mt-2 text-xl font-bold">
                    みんなの資産推移をチェック！
                  </div>
                  <div className="mt-1 text-link">
                    <a
                      href="https://twitter.com/search?q=%23%E3%82%A2%E3%82%BB%E3%83%97%E3%83%A9&src=hashtag_click"
                      target="_blank"
                      rel="noopener">
                      #アセプラ
                    </a>
                  </div>
                </div>
              </div>
              {/* SP */}
              <div className="bg-white border rounded-lg shadow-panel py-10 px-6 lg:hidden">
                <div className="">
                  <div className="login-app flex items-center justify-center login-app-banner">
                    <div className="flex justify-center w-full">
                      <div className="flex flex-col justify-end max-w-375p">
                        <div className="flex items-end justify-between mb-6 app-primary-label-block">
                          <div className="inline-flex items-center flex-col text-bluegray-700 font-bold">
                            フォローはこちらから
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-row justify-center">
                    <a
                      href="https://twitter.com/minkabu_asepla"
                      target="_blank"
                      rel="noopener">
                      <img
                        src="/static/images/lp/x_icon.svg"
                        alt="twitter"
                        width="75"
                        height="75"
                      />
                    </a>
                  </div>
                </div>
                <div className="mt-6 text-base">
                  <div className="text-xl font-bold">
                    アセプラ公式 X アカウント
                  </div>
                  <div className="mt-1">
                    アセプラの活用方法やリリース情報をお知らせします。
                  </div>
                  <div className="mt-1 text-link">
                    <a
                      href="https://twitter.com/minkabu_asepla"
                      target="_blank"
                      rel="noopener">
                      @minkabu_asepla
                    </a>
                  </div>
                  <div className="mt-2 text-xl font-bold">
                    みんなの資産推移をチェック！
                  </div>
                  <div className="mt-1 text-link">
                    <a
                      href="https://twitter.com/search?q=%23%E3%82%A2%E3%82%BB%E3%83%97%E3%83%A9&src=hashtag_click"
                      target="_blank"
                      rel="noopener">
                      #アセプラ
                    </a>
                  </div>
                </div>
              </div>
            </section>
            {/*FAQ/よくある質問*/}
            <section className="bg-white pt-16 pb-16 js-ui-animation-fadeup">
              <div className="container px-2">
                <div className="text-center mb-8">
                  <h2 id="faq" className="lg:text-3xl text-xl font-bold">
                    FAQ/よくある質問
                  </h2>
                  <div className="h-4 w-64 bg-red-500 right-half mx-auto mt-2"></div>
                </div>

                <div className="p-4  leading-relax">
                  <dl>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="flex flex-row items-baseline font-bold">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        アセプラ（みんかぶアセットプランナー）とは何ですか？
                      </dt>
                      <dd className="flex flex-row items-baseline">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span>
                          アセプラとは株式投資や投資信託を管理、分析する投資管理アプリです。複数の証券口座や銀行口座にある資産をまとめて、チャートやグラフで確認できます。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="flex flex-row items-baseline font-bold">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        登録できる証券会社はどこですか？
                      </dt>
                      <dd className="flex flex-row items-baseline">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span>
                          SBI証券、楽天証券、松井証券、三菱UFJ
                          eスマート証券などの口座をご登録いただけます。マネーツリーアカウントを連携することで評価額と保有銘柄情報のみ20以上の証券会社の連携が可能になります。詳細は
                          <a
                            href="#accountinfo"
                            className="text-link underline">
                            コチラ
                          </a>
                          をご確認ください。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="flex flex-row items-baseline font-bold">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        連携が可能な金融商品はなんですか？
                      </dt>
                      <dd className="flex flex-row items-baseline">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span>
                          現在は国内株式（現物・信用）、外国株式（米国）の連携が可能です。特定口座/NISA/一般口座に対応しております。
                          （一般口座では保有株式については反映されますが損益は反映されません）
                          今後、他の金融商品の連携ができるよう準備を進めてまいります。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="flex flex-row items-baseline font-bold">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        アセプラの始め方は？
                      </dt>
                      <dd className="flex flex-row items-baseline">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span>
                          みんかぶ会員登録を行います。登録完了後、ログイン後の「口座一覧」画面からお持ちの証券口座の情報を入力して口座を連携してください
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="flex flex-row items-baseline font-bold">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        アセプラの利用料金は？
                      </dt>
                      <dd className="flex flex-row items-baseline">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        SBI証券の口座をお持ちの方は一部の機能（複数口座連携、資産目標サポート、週次・月次レポートなど）を除き無料でご利用いただけます。
                        アセプラのすべての機能のご利用には月額課金サービス「みんかぶプレミアム（税込1,320円/月）」にご登録が必要です。初回登録のみ30日間無料でご利用いただけます。
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="flex flex-row items-baseline font-bold">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        口座を登録しましたが、データが表示されません。
                      </dt>
                      <dd className="flex flex-row items-baseline">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span>
                          口座登録直後、データを取得・反映しておりますのでしばらくお待ちください。
                          初回のデータ取得にはお時間がかかる可能性がございますのでご了承ください。
                          2回目以降のデータ更新は平日の18:00頃行います。
                          証券会社や取引データの量によってお時間がかかる場合がございますので、しばらくお待ちいただけますようお願いいたします。
                        </span>
                      </dd>
                    </div>

                    <div className="border-b border-gray-500 py-4">
                      <dt className="flex flex-row items-baseline font-bold">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        <span>
                          以前、無料体験をしたことがありますが、また無料体験を利用できますか？
                        </span>
                      </dt>
                      <dd className="flex flex-row items-baseline">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span>
                          「無料体験」は、お一人様につき初回登録時の1回限りとなります。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="flex flex-row items-baseline font-bold">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        「無料体験」の期間中でも解約できますか？
                      </dt>
                      <dd className="flex flex-row items-baseline">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span>
                          「無料体験」の期間中に利用停止手続きをすると、無料のまま解約でき、ご利用料金は発生しません。解約ご希望の場合は、必ずご自身でお手続きください。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="flex flex-row items-baseline font-bold">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        料金の請求はいつからですか？
                      </dt>
                      <dd className="flex flex-row items-baseline">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span>
                          ご登録日から30日間無料となり無料期間終了翌日から有料期間に自動移行します。
                          月々の引き落としが実際に行われるタイミングはカード会社によって異なります。
                          詳しくはカード会社までお問い合わせください。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="flex flex-row items-baseline font-bold">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        利用できる支払い方法は？
                      </dt>
                      <dd className="flex flex-row items-baseline">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span>
                          みんかぶプレミアムのお支払いには、クレジットカードまたはデビットカードをご利用いただけます。
                          <br />
                          ※銀行振込、コンビニ払い等は扱っておりません。
                        </span>
                      </dd>
                    </div>

                    <div className="border-b border-gray-500 py-4">
                      <dt className="flex flex-row items-baseline font-bold">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        法人契約で利用することは可能ですか？
                      </dt>
                      <dd className="flex flex-row items-baseline">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span>
                          「みんかぶプレミアム」で提供するサービスは、個人の私的利用に限定させていただいております。
                          法人契約でのご利用はできません。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="flex flex-row items-baseline font-bold">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        みんかぶプレミアムを解約後、また利用を再開することはできますか？
                      </dt>
                      <dd className="flex flex-row items-baseline">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span>
                          はい、
                          <a href="https://id.minkabu.jp/settings">
                            みんかぶ会員画面
                          </a>
                          より再開することが可能です。「解約」は定期購入の停止という扱いとなり、一時停止中の取引履歴は取得されません。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="flex flex-row items-baseline font-bold">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        みんかぶプレミアムの解約手続き後、いつまで利用することができますか？
                      </dt>
                      <dd className="flex flex-row items-baseline">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span>
                          解約は定期購入の停止という扱いとなります。定期購入の停止のお手続き後、次回契約更新日の前日までご利用いただけます。
                        </span>
                      </dd>
                    </div>
                  </dl>
                </div>
              </div>
            </section>
            {/*運営元・関連情報*/}
            <section className=" pt-16 pb-16 js-ui-animation-fadeup">
              <div className="container px-2">
                <div className="text-center mb-8">
                  <h2
                    id="asepla_information"
                    className="lg:text-3xl text-xl font-bold">
                    運営元・関連情報
                  </h2>
                  <div className="h-4 w-64 bg-red-500 right-half mx-auto mt-2"></div>
                </div>
                <table className="text-center w-full lg:w-1/2 lg:mx-auto">
                  <tbody>
                    <tr className="border-b border-gray-400 py-4">
                      <th className="px-2 py-4 font-bold bg-gray-300 w-1/4">
                        名称
                      </th>
                      <td className="px-2 py-4 bg-white w-3/4">
                        MINKABU ASSET PLANNER
                        <br />
                        （みんかぶアセットプランナー）
                      </td>
                    </tr>
                    <tr className="border-b border-gray-400 py-4">
                      <td className="px-2 py-4 font-bold bg-gray-300">
                        提供元
                      </td>
                      <td className="px-2 py-4 bg-white">
                        株式会社ミンカブ・ジ・インフォノイド
                      </td>
                    </tr>
                    <tr className="border-b border-gray-400 py-4">
                      <td className="px-2 py-4 font-bold bg-gray-300">
                        料金プラン
                      </td>
                      <td className="px-2 py-4 bg-white">
                        <p className="fonnt-bold">
                          月額1,320円（税込）　※初回30日間無料
                        </p>
                        アセプラのご利用は基本有料となっております。
                        <br />
                        SBI証券口座連携のみ一部機能を無料でご利用いただけます。
                      </td>
                    </tr>
                    <tr className="border-b border-gray-400 py-4">
                      <td className="px-2 py-4 font-bold bg-gray-300">
                        利用環境
                      </td>
                      <td className="px-2 py-4 bg-white">
                        【Android】OS 9.0以上
                        <br />
                        【iPhone】iOS 13.0以上
                      </td>
                    </tr>
                    <tr className="border-b border-gray-400 py-4">
                      <td className="px-2 py-4 font-bold bg-gray-300">
                        注意事項
                      </td>
                      <td className="px-2 py-4 bg-white text-sm text-left">
                        ・MINKABU ASSET PLANNERは株式会社MONO
                        Investmentが提供するデータ収集システムおよび、マネーツリー株式会社が提供するMoneytree
                        LINK
                        APIを利用し、各証券会社や金融機関のWebサイトから情報を取得します。
                        <br />
                        ・SBI証券の「PC登録あんしんサービス」をご利用の口座はサービスをご利用いただけません。
                        <br />
                        証券会社Webサイトにて、ユーザーネームを変更された場合は、変更後の口座を新たに登録する必要があります。
                        <br />
                        変更後の口座は変更前の口座とは別の口座として扱われ、データは引き継がれません。
                        <br />
                        例 )<br />
                        資産推移画面で推移グラフが連続しない
                        <br />
                        取引詳細の「理由」欄が引き継がれない
                        <br />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <a href="#top" className="ui-float-button bg-blue text-lg z-40">
              <i className="icon-arrow-up" title="ページTOPへ"></i>
            </a>
            {/*アセプラのアプリを無料でダウンロード*/}
            <div className="bg-white px-9 rounded mx-4 lg:mx-auto mb-10 px-6 py-10 lg:max-w-3xl footer-app-block border">
              <div className="login-app flex items-center justify-center login-app-banner">
                <div className="flex justify-center w-full">
                  <div className="flex flex-col justify-end max-w-375p">
                    <div className="flex items-end justify-between mb-6 lg:mb-auto app-primary-label-block">
                      <div className="inline-flex items-center flex-col lg:flex-row text-bluegray-700 font-bold">
                        <span>アセプラのアプリを</span>
                        <span>無料でダウンロード</span>
                      </div>
                    </div>
                    <ul className="flex justify-center items-center">
                      <li className="cursor-pointer hover:opacity-75 active:opacity-75">
                        <a
                          href="https://play.google.com/store/apps/details?id=jp.minkabu.ap"
                          target="_blank"
                          rel="noopener">
                          <img
                            src="/static/images/lp/google-play-badge.svg"
                            alt="badge"
                            width="174"
                            height="50"
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="hidden lg:flex">
                    <ul className="flex">
                      <li className="ml-8">
                        <div
                          className="text-sm
                        text-bluegray-500
                        text-center
                        leading-5">
                          Android
                        </div>
                        <div className="rounded p-1 bg-white">
                          <img
                            src="/static/images/lp/map-googleplay.svg"
                            alt="map"
                            width="80"
                            height="80"
                          />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        <div id="footer" className="bg-gray-800 py-4 px-2 text-white text-sm">
          <div className="container">
            <ul className="text-center mb-8">
              <li className="inline-block mr-4">
                <a href="https://minkabu.co.jp/" target="_blank" rel="noopener">
                  運営会社
                </a>
              </li>
              <li className="inline-block mr-4">
                <a
                  href="https://info.minkabu.jp/tw_terms/"
                  target="_blank"
                  rel="noopener">
                  利用規約
                </a>
              </li>
              <li className="inline-block mr-4">
                <a
                  href="https://minkabu.co.jp/privacy_policy"
                  target="_blank"
                  rel="noopener">
                  プライバシーポリシー
                </a>
              </li>
              {!isIosApp() && (
                <>
                  <li className="inline-block mr-4">
                    <a
                      href="https://info.minkabu.jp/economy/"
                      target="_blank"
                      rel="noopener">
                      特定商取引表示
                    </a>
                  </li>
                  <li className="inline-block mr-4">
                    <a
                      href="https://info.minkabu.jp/law/"
                      target="_blank"
                      rel="noopener">
                      ご利用上の注意（関連法規）
                    </a>
                  </li>
                  <li className="inline-block mr-4">
                    <a
                      href="https://info.minkabu.jp/ad/"
                      target="_blank"
                      rel="noopener">
                      広告掲載・取扱商品
                    </a>
                  </li>
                  <li className="inline-block mr-4">
                    <a
                      href="https://support.minkabu.jp/hc/ja"
                      target="_blank"
                      rel="noopener">
                      ヘルプ/FAQ
                    </a>
                  </li>
                </>
              )}
            </ul>
            <div className="copyright mb-4">
              <a
                href="https://minkabu.co.jp/"
                className="text-center"
                title="株式会社ミンカブ・ジ・インフォノイドコーポレートサイトへ"
                target="_blank"
                rel="noopener">
                <img
                  loading="lazy"
                  src="/static/images/lp/min_infonoid_logo_white.svg"
                  width="150"
                  height="25"
                  className="mx-auto"
                  alt="ミンカブ・ジ・インフォノイド ロゴ"
                />
              </a>
              <div className="text-center">
                <span className="dptblc tar vabt">
                  (C) MINKABU THE INFONOID, Inc.
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* モーダル */}
        <div
          className={`js_modal ui-modal z-50 container ${
            showImage !== '' ? 'is-visible' : ''
          }`}>
          <div>
            <div className="ui-card w-full shadow-lg text-gray-700 p-4">
              <div className="mb-2 flex justify-between">
                <div>
                  <i
                    className="icon-close js_toggle_switch text-xl text-gray-500 cursor-pointer"
                    data-toggle="js_modal"
                    title="閉じる"
                    onClick={closeModal}
                  />
                </div>
              </div>
              <div className="w-full  mx-auto">
                <div className="mb-4">
                  <img src={showImage} className="modal-image" alt="拡大画像" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="ui-layer z-40 js_toggle_switch"
          data-toggle="js_modal"
          onClick={closeModal}
        />
      </div>
    </>
  );
};
/* eslint-enable react/jsx-no-target-blank */

const LoginNotification = ({
  notificationItems,
}: {
  notificationItems: NotificationItems[];
}): React.ReactElement => {
  const history = useHistory();
  const gotoLoginNotificationDetail = useCallback(
    (notificationID: string): void => {
      history.push(`/loginNotificationDetail/${notificationID}`);
    },
    [history]
  );
  return (
    <section className="container rounded-lg px-2 mb-16">
      <div className="flex flex-col bg-white border border-solid rounded-lg shadow-panel mb-4 lg:mb-8 lg:mx-24 lg:max-w-864p lg:mx-auto">
        {notificationItems.map((item, key) => {
          const dispTime = item.UpdTime ?? item.InsTime;
          return (
            <div key={key}>
              {/* PC */}
              <div className="border-b border-solid lg:flex hidden cursor-pointer">
                <div
                  className="px-12 py-8 w-full"
                  onClick={() => gotoLoginNotificationDetail(item.ID)}>
                  <div className="flex flex-row items-center">
                    <div className="flex flex-row w-2/3">
                      <div className="icon-info text-red-600 text-lg"></div>
                      <div className="text-red-600 ml-1">{item.Title}</div>
                    </div>
                    <div className="ml-8 text-gray-500 text-sm">
                      {formatDate(new Date(dispTime), 'yyyy/MM/dd')}
                    </div>
                    <div className="ml-auto px-1 justify-center items-center flex flex-row text-gray-500">
                      <div className="mr-2 text-sm">詳細を見る</div>
                      <div className="icon-chevron-right flex flex-row text-2xl"></div>
                    </div>
                  </div>
                </div>
              </div>
              {/* SP */}
              <div className="border-b border-solid lg:hidden">
                <div
                  className="px-4 py-6 flex flex-row"
                  onClick={() => gotoLoginNotificationDetail(item.ID)}>
                  <div className="flex flex-col">
                    <div className="flex flex-row">
                      <div className="icon-info text-red-600 text-lg"></div>
                      <div className="text-red-600 ml-1">{item.Title}</div>
                    </div>
                    <div className="ml-5 text-gray-500 text-sm">
                      {formatDate(new Date(dispTime), 'yyyy/MM/dd')}
                    </div>
                  </div>
                  <div className="ml-auto px-1 justify-center items-center flex flex-row text-gray-500">
                    <div className="icon-chevron-right flex flex-row text-2xl"></div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Login;
